// // // // // // // // // // // import React, { useState } from "react";
// // // // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // // import { usePriceData } from "../context/PriceContext";
// // // // // // // // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // // // // // // // import { FaMapMarkerAlt, FaUsers, FaSearch } from "react-icons/fa";
// // // // // // // // // // // import i18n from "i18next";

// // // // // // // // // // // const MobileTransferSearch = () => {
// // // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // // //   const { t } = useTranslation("searchbox");
// // // // // // // // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // // // // // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // // // // // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // // // // // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // // // // // // // //   const regionOptions = ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle)];

// // // // // // // // // // //   // Çift yön mantığına göre fiyatı al
// // // // // // // // // // //   let regionKey = null;
// // // // // // // // // // //   if (selectedFrom === "Antalya Havalimanı") {
// // // // // // // // // // //     regionKey = selectedTo.toUpperCase();
// // // // // // // // // // //   } else if (selectedTo === "Antalya Havalimanı") {
// // // // // // // // // // //     regionKey = selectedFrom.toUpperCase();
// // // // // // // // // // //   }

// // // // // // // // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;
// // // // // // // // // // //   const vehicleKey = regionPrices && Object.keys(regionPrices)[0];
// // // // // // // // // // //   const rawPrice = regionPrices?.[vehicleKey];
// // // // // // // // // // //   // const price = rawPrice ? convertPrice(rawPrice, i18n.language) : null;

// // // // // // // // // // //   const handleSearch = (e) => {
// // // // // // // // // // //     e.preventDefault();
// // // // // // // // // // //     if (!selectedFrom || !selectedTo) return;

// // // // // // // // // // //     navigate(
// // // // // // // // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // // // // // // // //         selectedTo
// // // // // // // // // // //       )}&passengers=${passengerCount}`
// // // // // // // // // // //     );
// // // // // // // // // // //   };

// // // // // // // // // // //   return (
// // // // // // // // // // //     <div className="block md:hidden bg-black text-white pb-6 px-4 pt-2">
// // // // // // // // // // //       <form
// // // // // // // // // // //         onSubmit={handleSearch}
// // // // // // // // // // //         className="flex flex-col gap-4 max-w-xs mx-auto bg-gray-900 rounded-xl p-4 shadow-inner"
// // // // // // // // // // //       >
// // // // // // // // // // //         <h4 className="text-center text-lg text-yellow-500">{t("otherRegions")}</h4>

// // // // // // // // // // //         {/* Kalkış Yeri */}
// // // // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // // // //           <FaMapMarkerAlt />
// // // // // // // // // // //           <select
// // // // // // // // // // //             value={selectedFrom}
// // // // // // // // // // //             onChange={(e) => setSelectedFrom(e.target.value)}
// // // // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // // // //           >
// // // // // // // // // // //             {regionOptions.map((region, idx) => (
// // // // // // // // // // //               <option key={idx} value={region} className="text-black">
// // // // // // // // // // //                 {region}
// // // // // // // // // // //               </option>
// // // // // // // // // // //             ))}
// // // // // // // // // // //           </select>
// // // // // // // // // // //         </div>

// // // // // // // // // // //         {/* Varış Yeri */}
// // // // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // // // //           <FaMapMarkerAlt />
// // // // // // // // // // //           <select
// // // // // // // // // // //             value={selectedTo}
// // // // // // // // // // //             onChange={(e) => setSelectedTo(e.target.value)}
// // // // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // // // //           >
// // // // // // // // // // //             <option value="">{t("toPlaceholder")}</option>
// // // // // // // // // // //             {regionOptions
// // // // // // // // // // //               .filter((region) => region !== selectedFrom)
// // // // // // // // // // //               .map((region, idx) => (
// // // // // // // // // // //                 <option key={idx} value={region} className="text-black">
// // // // // // // // // // //                   {region}
// // // // // // // // // // //                 </option>
// // // // // // // // // // //               ))}
// // // // // // // // // // //           </select>
// // // // // // // // // // //         </div>

// // // // // // // // // // //         {/* Yolcu Sayısı */}
// // // // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // // // //           <FaUsers />
// // // // // // // // // // //           <select
// // // // // // // // // // //             value={passengerCount}
// // // // // // // // // // //             onChange={(e) => setPassengerCount(e.target.value)}
// // // // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // // // //           >
// // // // // // // // // // //             {[...Array(14)].map((_, i) => (
// // // // // // // // // // //               <option key={i + 1} value={i + 1} className="text-black">
// // // // // // // // // // //                 {t("passengers")}: {i + 1}
// // // // // // // // // // //               </option>
// // // // // // // // // // //             ))}
// // // // // // // // // // //           </select>
// // // // // // // // // // //         </div>

// // // // // // // // // // //         {/* Fiyat Gösterimi */}
// // // // // // // // // // //         {/* {selectedTo && (
// // // // // // // // // // //           <div className="text-center text-sm font-medium">
// // // // // // // // // // //             {price ? (
// // // // // // // // // // //               <span className="text-green-400">Fiyat: {price}</span>
// // // // // // // // // // //             ) : (
// // // // // // // // // // //               <span className="text-red-400">Bu yön için fiyat bilgisi yok</span>
// // // // // // // // // // //             )}
// // // // // // // // // // //           </div>
// // // // // // // // // // //         )} */}

// // // // // // // // // // //         {/* Ara Butonu */}
// // // // // // // // // // //         <button
// // // // // // // // // // //           type="submit"
// // // // // // // // // // //           className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-4 py-2 rounded-lg transition-all"
// // // // // // // // // // //         >
// // // // // // // // // // //           <FaSearch /> {t("search")}
// // // // // // // // // // //         </button>
// // // // // // // // // // //       </form>
// // // // // // // // // // //     </div>
// // // // // // // // // // //   );
// // // // // // // // // // // };

// // // // // // // // // // // export default MobileTransferSearch;
// // // // // // // // // // import React, { useMemo, useState } from "react";
// // // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // // import { usePriceData } from "../context/PriceContext";
// // // // // // // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // // // // // // import { FaMapMarkerAlt, FaUsers, FaSearch } from "react-icons/fa";
// // // // // // // // // // import i18n from "i18next";

// // // // // // // // // // /**
// // // // // // // // // //  * !!! ÖNEMLİ !!!
// // // // // // // // // //  * Aşağıdaki vehicle.key değerleri, PriceContext içindeki bölge fiyatları
// // // // // // // // // //  * ile birebir aynı olmalı. (ör: prices['LARA']['ECONOMIC_SEDAN'] gibi)
// // // // // // // // // //  * İsim ve görselleri dilediğin gibi değiştirebilirsin.
// // // // // // // // // //  */
// // // // // // // // // // const VEHICLES = [
// // // // // // // // // //   {
// // // // // // // // // //     key: "ECONOMIC_SEDAN",
// // // // // // // // // //     name: "Economic Sedan",
// // // // // // // // // //     capacity: 4,
// // // // // // // // // //     img: "/images/vehicles/sedan.png",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     key: "MERCEDES_VITO",
// // // // // // // // // //     name: "Mercedes Vito",
// // // // // // // // // //     capacity: 6,
// // // // // // // // // //     img: "/images/vehicles/vito.png",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     key: "MINIBUS",
// // // // // // // // // //     name: "Minibus",
// // // // // // // // // //     capacity: 13,
// // // // // // // // // //     img: "/images/vehicles/minibus.png",
// // // // // // // // // //   },
// // // // // // // // // // ];

// // // // // // // // // // const MobileTransferSearch = () => {
// // // // // // // // // //   const navigate = useNavigate();
// // // // // // // // // //   const { t } = useTranslation("searchbox");
// // // // // // // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // // // // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // // // // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // // // // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // // // // // // //   // ===== Bölge seçenekleri =====
// // // // // // // // // //   const regionOptions = useMemo(
// // // // // // // // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // // // // // // // //     [pricesByRegionAndVehicle]
// // // // // // // // // //   );

// // // // // // // // // //   // ===== Çift yön mantığı: Airport <-> Bölge =====
// // // // // // // // // //   let regionKey = null;
// // // // // // // // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) {
// // // // // // // // // //     regionKey = selectedTo.toUpperCase();
// // // // // // // // // //   } else if (selectedTo === "Antalya Havalimanı" && selectedFrom) {
// // // // // // // // // //     regionKey = selectedFrom.toUpperCase();
// // // // // // // // // //   }

// // // // // // // // // //   // Bu bölgede araç başına fiyat tablosu (ör: { ECONOMIC_SEDAN: 25, MERCEDES_VITO: 35, ... })
// // // // // // // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // // // // // // // //   // ===== Yolcu sayısına göre araç seçenekleri =====
// // // // // // // // // //   const pax = Number(passengerCount || 1);
// // // // // // // // // //   const allowedVehicles =
// // // // // // // // // //     pax <= 6
// // // // // // // // // //       ? VEHICLES.filter((v) => v.capacity <= 6).slice(0, 2) // iki araç
// // // // // // // // // //       : VEHICLES.filter((v) => v.capacity > 6).slice(0, 1); // tek büyük araç

// // // // // // // // // //   // Seçili araç (liste değişince ilkini seç)
// // // // // // // // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0]?.key);
// // // // // // // // // //   React.useEffect(() => {
// // // // // // // // // //     setSelectedVehicleKey(allowedVehicles[0]?.key);
// // // // // // // // // //   }, [pax]); // yolcu sayısı değişince araç listesi de güncellenir

// // // // // // // // // //   // Seçili araç için fiyat (varsa)
// // // // // // // // // //   const selectedVehiclePriceRaw =
// // // // // // // // // //     regionPrices && selectedVehicleKey ? regionPrices[selectedVehicleKey] : null;
// // // // // // // // // //   const selectedVehiclePrice = selectedVehiclePriceRaw
// // // // // // // // // //     ? convertPrice(selectedVehiclePriceRaw, i18n.language)
// // // // // // // // // //     : null;

// // // // // // // // // //   // Kartların üzerinde göstereceğimiz fiyat (her araç için)
// // // // // // // // // //   const priceForVehicle = (vehicleKey) => {
// // // // // // // // // //     const val = regionPrices ? regionPrices[vehicleKey] : null;
// // // // // // // // // //     return val ? convertPrice(val, i18n.language) : null;
// // // // // // // // // //   };

// // // // // // // // // //   const handleSearch = (e) => {
// // // // // // // // // //     e.preventDefault();
// // // // // // // // // //     if (!selectedFrom || !selectedTo || !selectedVehicleKey) return;

// // // // // // // // // //     navigate(
// // // // // // // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // // // // // // //         selectedTo
// // // // // // // // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(selectedVehicleKey)}`
// // // // // // // // // //     );
// // // // // // // // // //   };

// // // // // // // // // //   return (
// // // // // // // // // //     <div className="block md:hidden bg-black text-white pb-6 px-4 pt-2">
// // // // // // // // // //       <form
// // // // // // // // // //         onSubmit={handleSearch}
// // // // // // // // // //         className="flex flex-col gap-4 max-w-xs mx-auto bg-gray-900 rounded-2xl p-4 shadow-inner"
// // // // // // // // // //       >
// // // // // // // // // //         {/* Başlık */}
// // // // // // // // // //         <h4 className="text-center text-lg font-semibold text-yellow-500">
// // // // // // // // // //           {t("otherRegions")}
// // // // // // // // // //         </h4>

// // // // // // // // // //         {/* From */}
// // // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // // //           <FaMapMarkerAlt />
// // // // // // // // // //           <select
// // // // // // // // // //             value={selectedFrom}
// // // // // // // // // //             onChange={(e) => setSelectedFrom(e.target.value)}
// // // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // // //           >
// // // // // // // // // //             {regionOptions.map((region, idx) => (
// // // // // // // // // //               <option key={idx} value={region} className="text-black">
// // // // // // // // // //                 {region}
// // // // // // // // // //               </option>
// // // // // // // // // //             ))}
// // // // // // // // // //           </select>
// // // // // // // // // //         </div>

// // // // // // // // // //         {/* To */}
// // // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // // //           <FaMapMarkerAlt />
// // // // // // // // // //           <select
// // // // // // // // // //             value={selectedTo}
// // // // // // // // // //             onChange={(e) => setSelectedTo(e.target.value)}
// // // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // // //           >
// // // // // // // // // //             <option value="">{t("toPlaceholder")}</option>
// // // // // // // // // //             {regionOptions
// // // // // // // // // //               .filter((region) => region !== selectedFrom)
// // // // // // // // // //               .map((region, idx) => (
// // // // // // // // // //                 <option key={idx} value={region} className="text-black">
// // // // // // // // // //                   {region}
// // // // // // // // // //                 </option>
// // // // // // // // // //               ))}
// // // // // // // // // //           </select>
// // // // // // // // // //         </div>

// // // // // // // // // //         {/* Passengers */}
// // // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // // //           <FaUsers />
// // // // // // // // // //           <select
// // // // // // // // // //             value={passengerCount}
// // // // // // // // // //             onChange={(e) => setPassengerCount(e.target.value)}
// // // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // // //           >
// // // // // // // // // //             {[...Array(14)].map((_, i) => (
// // // // // // // // // //               <option key={i + 1} value={i + 1} className="text-black">
// // // // // // // // // //                 {t("passengers")}: {i + 1}
// // // // // // // // // //               </option>
// // // // // // // // // //             ))}
// // // // // // // // // //           </select>
// // // // // // // // // //         </div>

// // // // // // // // // //         {/* Vehicle Selection */}
// // // // // // // // // //         <div className="bg-gray-800 rounded-lg p-3">
// // // // // // // // // //           <div className="text-sm text-gray-300 mb-2">{t("vehicleSelection") || "Vehicle Selection"}</div>
// // // // // // // // // //           <div className="flex gap-2 overflow-x-auto no-scrollbar">
// // // // // // // // // //             {allowedVehicles.map((v) => {
// // // // // // // // // //               const active = v.key === selectedVehicleKey;
// // // // // // // // // //               const price = priceForVehicle(v.key);
// // // // // // // // // //               return (
// // // // // // // // // //                 <button
// // // // // // // // // //                   type="button"
// // // // // // // // // //                   key={v.key}
// // // // // // // // // //                   onClick={() => setSelectedVehicleKey(v.key)}
// // // // // // // // // //                   className={`min-w-[180px] flex items-center gap-3 rounded-md border px-3 py-2 text-left ${
// // // // // // // // // //                     active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // // // // // // // //                   }`}
// // // // // // // // // //                 >
// // // // // // // // // //                   <img src={v.img} alt={v.name} className="w-12 h-10 object-contain" />
// // // // // // // // // //                   <div className="flex-1">
// // // // // // // // // //                     <div className="text-white text-sm font-medium">{v.name}</div>
// // // // // // // // // //                     <div className="text-xs text-gray-400">
// // // // // // // // // //                       {t("passengers")}: {v.capacity}
// // // // // // // // // //                     </div>
// // // // // // // // // //                   </div>
// // // // // // // // // //                   {price && (
// // // // // // // // // //                     <div className="text-sm font-bold text-yellow-400 whitespace-nowrap">
// // // // // // // // // //                       {price}
// // // // // // // // // //                     </div>
// // // // // // // // // //                   )}
// // // // // // // // // //                 </button>
// // // // // // // // // //               );
// // // // // // // // // //             })}
// // // // // // // // // //           </div>
// // // // // // // // // //           {/* Seçili araç ve fiyat mini özet */}
// // // // // // // // // //           {selectedVehicleKey && (
// // // // // // // // // //             <div className="text-xs text-gray-300 mt-2">
// // // // // // // // // //               {selectedVehiclePrice
// // // // // // // // // //                 ? `${t("vehicleSelection") || "Vehicle"}: ${selectedVehicleKey} • ${selectedVehiclePrice}`
// // // // // // // // // //                 : `${t("vehicleSelection") || "Vehicle"}: ${selectedVehicleKey}`}
// // // // // // // // // //             </div>
// // // // // // // // // //           )}
// // // // // // // // // //         </div>

// // // // // // // // // //         {/* Search */}
// // // // // // // // // //         <button
// // // // // // // // // //           type="submit"
// // // // // // // // // //           className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-4 py-2 rounded-lg transition-all"
// // // // // // // // // //         >
// // // // // // // // // //           <FaSearch /> {t("search")}
// // // // // // // // // //         </button>
// // // // // // // // // //       </form>
// // // // // // // // // //     </div>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default MobileTransferSearch;
// // // // // // // // // // src/components/MobileTransferSearch.jsx
// // // // // // // // // import React, { useMemo, useState, useEffect } from "react";
// // // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // // import { usePriceData } from "../context/PriceContext";
// // // // // // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // // // // // import { FaMapMarkerAlt, FaUsers, FaSearch } from "react-icons/fa";
// // // // // // // // // import i18n from "i18next";

// // // // // // // // // // Görseller (public altında)
// // // // // // // // // const IMG = {
// // // // // // // // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // // // // // // // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // // // // // // // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // // // // // // // };

// // // // // // // // // // Araç tanımları (anahtarlar URL ve fiyat eşlemesi için kullanılıyor)
// // // // // // // // // const VEHICLES_ALL = [
// // // // // // // // //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6, img: IMG.MERCEDES8, match: ["VITO", "MERCEDES8", "MERCEDES"] },
// // // // // // // // //   { key: "TRANSPORTER", name: "Transporter", capacity: 6, img: IMG.TRANSPORTER, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
// // // // // // // // //   { key: "SPRINTER", name: "Sprinter", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER", "MINIBUS", "BUS"] },
// // // // // // // // // ];

// // // // // // // // // // RegionPrices içindeki anahtarlar farklı yazılmış olabilir.
// // // // // // // // // // Bu fonksiyon isimlerden akıllı bir eşleştirme yapar.
// // // // // // // // // function findPriceKey(regionPrices, matchKeywords) {
// // // // // // // // //   if (!regionPrices) return null;
// // // // // // // // //   const keys = Object.keys(regionPrices || {});
// // // // // // // // //   const upper = keys.map((k) => [k, k.toUpperCase()]);
// // // // // // // // //   for (const keyword of matchKeywords) {
// // // // // // // // //     const hit = upper.find(([, U]) => U.includes(keyword));
// // // // // // // // //     if (hit) return hit[0]; // orijinal anahtarı döndür
// // // // // // // // //   }
// // // // // // // // //   return null;
// // // // // // // // // }

// // // // // // // // // const MobileTransferSearch = () => {
// // // // // // // // //   const navigate = useNavigate();
// // // // // // // // //   const { t } = useTranslation("searchbox");
// // // // // // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // // // // // //   // ====== Form state ======
// // // // // // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // // // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // // // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // // // // // //   // Tarih/saat varsayılanları
// // // // // // // // //   const todayISO = new Date().toISOString().split("T")[0];
// // // // // // // // //   const nextHour = (() => {
// // // // // // // // //     const d = new Date();
// // // // // // // // //     d.setMinutes(0, 0, 0);
// // // // // // // // //     d.setHours(d.getHours() + 1);
// // // // // // // // //     return d.toTimeString().slice(0, 5); // HH:MM
// // // // // // // // //   })();

// // // // // // // // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // // // // // // // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // // // // // // // //   // Bölge seçenekleri
// // // // // // // // //   const regionOptions = useMemo(
// // // // // // // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // // // // // // //     [pricesByRegionAndVehicle]
// // // // // // // // //   );

// // // // // // // // //   // Çift yön – Airport <-> Bölge
// // // // // // // // //   let regionKey = null;
// // // // // // // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) {
// // // // // // // // //     regionKey = selectedTo.toUpperCase();
// // // // // // // // //   } else if (selectedTo === "Antalya Havalimanı" && selectedFrom) {
// // // // // // // // //     regionKey = selectedFrom.toUpperCase();
// // // // // // // // //   }
// // // // // // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // // // // // // //   // Yolcu sayısına göre araç listesi
// // // // // // // // //   const pax = Number(passengerCount || 1);
// // // // // // // // //   const allowedVehicles = pax <= 6
// // // // // // // // //     ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] // mercedes8 + transporter
// // // // // // // // //     : [VEHICLES_ALL[2]];                 // sprinter

// // // // // // // // //   // Seçilen araç
// // // // // // // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // // // // // // // //   useEffect(() => {
// // // // // // // // //     // yolcu sayısı değişince default ilk uygun aracı seç
// // // // // // // // //     setSelectedVehicleKey(allowedVehicles[0].key);
// // // // // // // // //   }, [pax]);

// // // // // // // // //   // Bir araç için (eşleşiyorsa) fiyatı bul
// // // // // // // // //   const priceForVehicle = (vehicle) => {
// // // // // // // // //     if (!regionPrices) return null;
// // // // // // // // //     const priceKey = findPriceKey(regionPrices, vehicle.match) || vehicle.key;
// // // // // // // // //     const raw = regionPrices[priceKey];
// // // // // // // // //     return raw ? convertPrice(raw, i18n.language) : null;
// // // // // // // // //   };

// // // // // // // // //   // Seçili araç fiyatı
// // // // // // // // //   const selectedVehicleDef = allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];
// // // // // // // // //   const selectedVehiclePrice = priceForVehicle(selectedVehicleDef);

// // // // // // // // //   // Arama
// // // // // // // // //   const handleSearch = (e) => {
// // // // // // // // //     e.preventDefault();
// // // // // // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;

// // // // // // // // //     navigate(
// // // // // // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // // // // // //         selectedTo
// // // // // // // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // // // // // // // //         selectedVehicleKey
// // // // // // // // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // // // // // // // //     );
// // // // // // // // //   };

// // // // // // // // //   return (
// // // // // // // // //     <div className="block md:hidden bg-black text-white pb-6 px-4 pt-2">
// // // // // // // // //       <form
// // // // // // // // //         onSubmit={handleSearch}
// // // // // // // // //         className="flex flex-col gap-4 max-w-xs mx-auto bg-gray-900 rounded-2xl p-4 shadow-inner"
// // // // // // // // //       >
// // // // // // // // //         {/* Başlık */}
// // // // // // // // //         <h4 className="text-center text-lg font-semibold text-yellow-500">
// // // // // // // // //           {t("quickReservation") || "Quick Reservation"}
// // // // // // // // //         </h4>

// // // // // // // // //         {/* From */}
// // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // //           <FaMapMarkerAlt />
// // // // // // // // //           <select
// // // // // // // // //             value={selectedFrom}
// // // // // // // // //             onChange={(e) => setSelectedFrom(e.target.value)}
// // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // //           >
// // // // // // // // //             {regionOptions.map((region, idx) => (
// // // // // // // // //               <option key={idx} value={region} className="text-black">
// // // // // // // // //                 {region}
// // // // // // // // //               </option>
// // // // // // // // //             ))}
// // // // // // // // //           </select>
// // // // // // // // //         </div>

// // // // // // // // //         {/* To */}
// // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // //           <FaMapMarkerAlt />
// // // // // // // // //           <select
// // // // // // // // //             value={selectedTo}
// // // // // // // // //             onChange={(e) => setSelectedTo(e.target.value)}
// // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // //           >
// // // // // // // // //             <option value="">{t("toPlaceholder") || "Select Drop-off Location"}</option>
// // // // // // // // //             {regionOptions
// // // // // // // // //               .filter((region) => region !== selectedFrom)
// // // // // // // // //               .map((region, idx) => (
// // // // // // // // //                 <option key={idx} value={region} className="text-black">
// // // // // // // // //                   {region}
// // // // // // // // //                 </option>
// // // // // // // // //               ))}
// // // // // // // // //           </select>
// // // // // // // // //         </div>

// // // // // // // // //         {/* Vehicle Selection */}
// // // // // // // // //         <div className="bg-gray-800 rounded-lg p-3">
// // // // // // // // //           <div className="text-sm text-gray-300 mb-2">
// // // // // // // // //             {t("vehicleSelection") || "Vehicle Selection"}
// // // // // // // // //           </div>

// // // // // // // // //           {/* Seçenekler */}
// // // // // // // // //           <div className="flex gap-2 overflow-x-auto no-scrollbar">
// // // // // // // // //             {allowedVehicles.map((v) => {
// // // // // // // // //               const active = v.key === selectedVehicleKey;
// // // // // // // // //               const price = priceForVehicle(v);
// // // // // // // // //               return (
// // // // // // // // //                 <button
// // // // // // // // //                   type="button"
// // // // // // // // //                   key={v.key}
// // // // // // // // //                   onClick={() => setSelectedVehicleKey(v.key)}
// // // // // // // // //                   className={`min-w-[220px] flex items-center gap-3 rounded-md border px-3 py-2 text-left ${
// // // // // // // // //                     active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // // // // // // //                   }`}
// // // // // // // // //                 >
// // // // // // // // //                   <img src={v.img} alt={v.name} className="w-14 h-12 object-contain" />
// // // // // // // // //                   <div className="flex-1">
// // // // // // // // //                     <div className="text-white text-sm font-medium">{v.name}</div>
// // // // // // // // //                     <div className="text-xs text-gray-400">
// // // // // // // // //                       {(t("passengers") || "Passengers")}: {v.capacity}
// // // // // // // // //                     </div>
// // // // // // // // //                   </div>
// // // // // // // // //                   {price && (
// // // // // // // // //                     <div className="text-sm font-bold text-yellow-400 whitespace-nowrap">
// // // // // // // // //                       {price}
// // // // // // // // //                     </div>
// // // // // // // // //                   )}
// // // // // // // // //                 </button>
// // // // // // // // //               );
// // // // // // // // //             })}
// // // // // // // // //           </div>

// // // // // // // // //           {/* Seçili araç kısa özet */}
// // // // // // // // //           {selectedVehicleKey && (
// // // // // // // // //             <div className="text-xs text-gray-300 mt-2">
// // // // // // // // //               {(t("vehicleSelection") || "Vehicle")}: {selectedVehicleDef.name}
// // // // // // // // //               {selectedVehiclePrice ? ` • ${selectedVehiclePrice}` : ""}
// // // // // // // // //             </div>
// // // // // // // // //           )}
// // // // // // // // //         </div>

// // // // // // // // //         {/* Pickup date & time */}
// // // // // // // // //         <div className="grid grid-cols-2 gap-3">
// // // // // // // // //           <div className="bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // //             <div className="text-xs text-gray-300 mb-1">{t("pickupDate") || "Pickup date"}</div>
// // // // // // // // //             <input
// // // // // // // // //               type="date"
// // // // // // // // //               value={pickupDate}
// // // // // // // // //               onChange={(e) => setPickupDate(e.target.value)}
// // // // // // // // //               className="w-full bg-transparent text-white focus:outline-none"
// // // // // // // // //             />
// // // // // // // // //           </div>
// // // // // // // // //           <div className="bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // //             <div className="text-xs text-gray-300 mb-1">{t("pickupTime") || "Pickup time"}</div>
// // // // // // // // //             <input
// // // // // // // // //               type="time"
// // // // // // // // //               value={pickupTime}
// // // // // // // // //               onChange={(e) => setPickupTime(e.target.value)}
// // // // // // // // //               className="w-full bg-transparent text-white focus:outline-none"
// // // // // // // // //             />
// // // // // // // // //           </div>
// // // // // // // // //         </div>

// // // // // // // // //         {/* Passengers */}
// // // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // // //           <FaUsers />
// // // // // // // // //           <select
// // // // // // // // //             value={passengerCount}
// // // // // // // // //             onChange={(e) => setPassengerCount(e.target.value)}
// // // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // // //           >
// // // // // // // // //             {[...Array(14)].map((_, i) => (
// // // // // // // // //               <option key={i + 1} value={i + 1} className="text-black">
// // // // // // // // //                 {(t("passengers") || "Passengers")}: {i + 1}
// // // // // // // // //               </option>
// // // // // // // // //             ))}
// // // // // // // // //           </select>
// // // // // // // // //         </div>

// // // // // // // // //         {/* Search */}
// // // // // // // // //         <button
// // // // // // // // //           type="submit"
// // // // // // // // //           className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-4 py-2 rounded-lg transition-all"
// // // // // // // // //         >
// // // // // // // // //           <FaSearch /> {t("search")}
// // // // // // // // //         </button>
// // // // // // // // //       </form>
// // // // // // // // //     </div>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default MobileTransferSearch;
// // // // // // // // // src/components/MobileTransferSearch.jsx
// // // // // // // // import React, { useMemo, useState, useEffect } from "react";
// // // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // // import { usePriceData } from "../context/PriceContext";
// // // // // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // // // // import { FaMapMarkerAlt, FaUsers, FaSearch, FaWhatsapp } from "react-icons/fa";
// // // // // // // // import i18n from "i18next";

// // // // // // // // // public/images/transfer/vehicles/ altında bulunan görseller
// // // // // // // // const IMG = {
// // // // // // // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // // // // // // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // // // // // // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // // // // // // };

// // // // // // // // const VEHICLES_ALL = [
// // // // // // // //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6, img: IMG.MERCEDES8, match: ["VITO", "MERCEDES8", "MERCEDES"] },
// // // // // // // //   { key: "TRANSPORTER", name: "Transporter", capacity: 6, img: IMG.TRANSPORTER, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
// // // // // // // //   { key: "SPRINTER", name: "Sprinter (Minibus)", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER", "MINIBUS", "BUS"] },
// // // // // // // // ];

// // // // // // // // // RegionPrices içindeki key isimleri farklıysa eşleştirmek için
// // // // // // // // function findPriceKey(regionPrices, matchKeywords) {
// // // // // // // //   if (!regionPrices) return null;
// // // // // // // //   const keys = Object.keys(regionPrices);
// // // // // // // //   const upper = keys.map((k) => [k, k.toUpperCase()]);
// // // // // // // //   for (const kw of matchKeywords) {
// // // // // // // //     const hit = upper.find(([, U]) => U.includes(kw));
// // // // // // // //     if (hit) return hit[0];
// // // // // // // //   }
// // // // // // // //   return null;
// // // // // // // // }

// // // // // // // // const MobileTransferSearch = () => {
// // // // // // // //   const navigate = useNavigate();
// // // // // // // //   const { t } = useTranslation("searchbox");
// // // // // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // // // // //   // tarih/saat default
// // // // // // // //   const todayISO = new Date().toISOString().split("T")[0];
// // // // // // // //   const nextHour = (() => {
// // // // // // // //     const d = new Date();
// // // // // // // //     d.setMinutes(0, 0, 0);
// // // // // // // //     d.setHours(d.getHours() + 1);
// // // // // // // //     return d.toTimeString().slice(0, 5);
// // // // // // // //   })();
// // // // // // // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // // // // // // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // // // // // // //   // bölge opsiyonları
// // // // // // // //   const regionOptions = useMemo(
// // // // // // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // // // // // //     [pricesByRegionAndVehicle]
// // // // // // // //   );

// // // // // // // //   // çift yön – fiyat tablosu bul
// // // // // // // //   let regionKey = null;
// // // // // // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) {
// // // // // // // //     regionKey = selectedTo.toUpperCase();
// // // // // // // //   } else if (selectedTo === "Antalya Havalimanı" && selectedFrom) {
// // // // // // // //     regionKey = selectedFrom.toUpperCase();
// // // // // // // //   }
// // // // // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // // // // // //   // pax -> araç listesi
// // // // // // // //   const pax = Number(passengerCount || 1);
// // // // // // // //   const allowedVehicles = pax <= 6
// // // // // // // //     ? [VEHICLES_ALL[0], VEHICLES_ALL[1]]        // mercedes8 & transporter
// // // // // // // //     : [VEHICLES_ALL[2]];                         // sprinter

// // // // // // // //   // seçili araç
// // // // // // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // // // // // // //   useEffect(() => {
// // // // // // // //     setSelectedVehicleKey(allowedVehicles[0].key);
// // // // // // // //   }, [pax]);

// // // // // // // //   // araç için fiyat
// // // // // // // //   const priceForVehicle = (v) => {
// // // // // // // //     if (!regionPrices) return null;
// // // // // // // //     const k = findPriceKey(regionPrices, v.match) || v.key;
// // // // // // // //     const raw = regionPrices[k];
// // // // // // // //     return raw ? convertPrice(raw, i18n.language) : null;
// // // // // // // //   };

// // // // // // // //   const selectedVehicleDef =
// // // // // // // //     allowedVehicles.find((v) => v.key === selectedVehicleKey) || allowedVehicles[0];

// // // // // // // //   const handleSearch = (e) => {
// // // // // // // //     e.preventDefault();
// // // // // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // // // // // // //     navigate(
// // // // // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // // // // //         selectedTo
// // // // // // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // // // // // // //         selectedVehicleKey
// // // // // // // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // // // // // // //     );
// // // // // // // //   };

// // // // // // // //   // WhatsApp: 90506685090 (ülke kodlu)
// // // // // // // //   const handleWhatsApp = () => {
// // // // // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;

// // // // // // // //     const msg =
// // // // // // // //       `Date: ${pickupDate}\n` +
// // // // // // // //       `Time: ${pickupTime}\n\n` +
// // // // // // // //       `From: ${selectedFrom}\n` +
// // // // // // // //       `To: ${selectedTo}\n` +
// // // // // // // //       `Persons: ${passengerCount}\n` +
// // // // // // // //       `Car: ${selectedVehicleDef.name}\n\n` +
// // // // // // // //       `ANTALYA VIP PICKUP`;

// // // // // // // //     const phone = "9054668301";
// // // // // // // //     const url = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
// // // // // // // //     window.open(url, "_blank");
// // // // // // // //   };

// // // // // // // //   return (
// // // // // // // //     <div className="block md:hidden bg-black text-white pb-6 px-4 pt-2">
// // // // // // // //       <form
// // // // // // // //         onSubmit={handleSearch}
// // // // // // // //         className="flex flex-col gap-4 max-w-xs mx-auto bg-gray-900 rounded-2xl p-4 shadow-inner"
// // // // // // // //       >
// // // // // // // //         {/* Başlık */}
// // // // // // // //         <h4 className="text-center text-lg font-semibold text-yellow-500">
// // // // // // // //           {t("Quick Reservation") || "Quick Reservation"}
// // // // // // // //         </h4>

// // // // // // // //         {/* From */}
// // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // //           <FaMapMarkerAlt />
// // // // // // // //           <select
// // // // // // // //             value={selectedFrom}
// // // // // // // //             onChange={(e) => setSelectedFrom(e.target.value)}
// // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // //           >
// // // // // // // //             {regionOptions.map((region, idx) => (
// // // // // // // //               <option key={idx} value={region} className="text-black">
// // // // // // // //                 {region}
// // // // // // // //               </option>
// // // // // // // //             ))}
// // // // // // // //           </select>
// // // // // // // //         </div>

// // // // // // // //         {/* To */}
// // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // //           <FaMapMarkerAlt />
// // // // // // // //           <select
// // // // // // // //             value={selectedTo}
// // // // // // // //             onChange={(e) => setSelectedTo(e.target.value)}
// // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // //           >
// // // // // // // //             <option value="">{t("toPlaceholder") || "Select Drop-off Location"}</option>
// // // // // // // //             {regionOptions
// // // // // // // //               .filter((region) => region !== selectedFrom)
// // // // // // // //               .map((region, idx) => (
// // // // // // // //                 <option key={idx} value={region} className="text-black">
// // // // // // // //                   {region}
// // // // // // // //                 </option>
// // // // // // // //               ))}
// // // // // // // //           </select>
// // // // // // // //         </div>

// // // // // // // //         {/* Vehicle Selection */}
// // // // // // // //         <div className="bg-gray-800 rounded-lg p-3">
// // // // // // // //           <div className="text-sm text-gray-300 mb-2">
// // // // // // // //             {t("vehicleSelection") || "Vehicle Selection"}
// // // // // // // //           </div>

// // // // // // // //           {/* ≤6 pax → iki kart ALT ALTA, >6 pax → tek kart */}
// // // // // // // //           <div className="flex flex-col gap-2">
// // // // // // // //             {allowedVehicles.map((v) => {
// // // // // // // //               const active = v.key === selectedVehicleKey;
// // // // // // // //               const price = priceForVehicle(v);
// // // // // // // //               return (
// // // // // // // //                 <button
// // // // // // // //                   type="button"
// // // // // // // //                   key={v.key}
// // // // // // // //                   onClick={() => setSelectedVehicleKey(v.key)}
// // // // // // // //                   className={`w-full flex items-center gap-3 rounded-md border px-3 py-2 text-left ${
// // // // // // // //                     active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // // // // // //                   }`}
// // // // // // // //                 >
// // // // // // // //                   <img src={v.img} alt={v.name} className="w-14 h-12 object-contain" />
// // // // // // // //                   <div className="flex-1">
// // // // // // // //                     <div className="text-white text-sm font-medium">{v.name}</div>
// // // // // // // //                     <div className="text-xs text-gray-400">
// // // // // // // //                       {(t("passengers") || "Passengers")}: {v.capacity}
// // // // // // // //                     </div>
// // // // // // // //                   </div>
// // // // // // // //                   {price && (
// // // // // // // //                     <div className="text-sm font-bold text-yellow-400 whitespace-nowrap">
// // // // // // // //                       {price}
// // // // // // // //                     </div>
// // // // // // // //                   )}
// // // // // // // //                 </button>
// // // // // // // //               );
// // // // // // // //             })}
// // // // // // // //           </div>

// // // // // // // //           {/* seçili araç özeti */}
// // // // // // // //           <div className="text-xs text-gray-300 mt-2">
// // // // // // // //             {(t("vehicleSelection") || "Vehicle")}: {selectedVehicleDef.name}
// // // // // // // //             {/* fiyat varsa göster */}
// // // // // // // //             {regionPrices && priceForVehicle(selectedVehicleDef)
// // // // // // // //               ? ` • ${priceForVehicle(selectedVehicleDef)}`
// // // // // // // //               : ""}
// // // // // // // //           </div>
// // // // // // // //         </div>

// // // // // // // //         {/* Pickup date & time */}
// // // // // // // //         <div className="grid grid-cols-2 gap-3">
// // // // // // // //           <div className="bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // //             <div className="text-xs text-gray-300 mb-1">{t("pickupDate") || "pickupDate"}</div>
// // // // // // // //             <input
// // // // // // // //               type="date"
// // // // // // // //               value={pickupDate}
// // // // // // // //               onChange={(e) => setPickupDate(e.target.value)}
// // // // // // // //               className="w-full bg-transparent text-white focus:outline-none"
// // // // // // // //             />
// // // // // // // //           </div>
// // // // // // // //           <div className="bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // //             <div className="text-xs text-gray-300 mb-1">{t("pickupTime") || "pickupTime"}</div>
// // // // // // // //             <input
// // // // // // // //               type="time"
// // // // // // // //               value={pickupTime}
// // // // // // // //               onChange={(e) => setPickupTime(e.target.value)}
// // // // // // // //               className="w-full bg-transparent text-white focus:outline-none"
// // // // // // // //             />
// // // // // // // //           </div>
// // // // // // // //         </div>

// // // // // // // //         {/* Passengers */}
// // // // // // // //         <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
// // // // // // // //           <FaUsers />
// // // // // // // //           <select
// // // // // // // //             value={passengerCount}
// // // // // // // //             onChange={(e) => setPassengerCount(e.target.value)}
// // // // // // // //             className="bg-transparent text-white w-full focus:outline-none"
// // // // // // // //           >
// // // // // // // //             {[...Array(14)].map((_, i) => (
// // // // // // // //               <option key={i + 1} value={i + 1} className="text-black">
// // // // // // // //                 {(t("passengers") || "Passengers")}: {i + 1}
// // // // // // // //               </option>
// // // // // // // //             ))}
// // // // // // // //           </select>
// // // // // // // //         </div>

// // // // // // // //         {/* WhatsApp – Search üstünde */}
// // // // // // // //         <button
// // // // // // // //           type="button"
// // // // // // // //           onClick={handleWhatsApp}
// // // // // // // //           className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-4 py-2 rounded-lg transition-all"
// // // // // // // //         >
// // // // // // // //           <FaWhatsapp /> Get a Price on WhatsApp
// // // // // // // //         </button>

// // // // // // // //         {/* Search */}
// // // // // // // //         <button
// // // // // // // //           type="submit"
// // // // // // // //           className="flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-4 py-2 rounded-lg transition-all"
// // // // // // // //         >
// // // // // // // //           <FaSearch /> {t("search")}
// // // // // // // //         </button>
// // // // // // // //       </form>
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileTransferSearch;
// // // // // // // // src/components/MobileTransferSearch.jsx
// // // // // // // import React, { useMemo, useState, useEffect } from "react";
// // // // // // // import { useNavigate } from "react-router-dom";
// // // // // // // import { useTranslation } from "react-i18next";
// // // // // // // import { usePriceData } from "../context/PriceContext";
// // // // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // // // import { FaMapMarkerAlt, FaUsers, FaSearch, FaWhatsapp } from "react-icons/fa";
// // // // // // // import i18n from "i18next";

// // // // // // // // Görseller
// // // // // // // const IMG = {
// // // // // // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // // // // // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // // // // // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // // // // // };

// // // // // // // const VEHICLES_ALL = [
// // // // // // //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6, img: IMG.MERCEDES8, match: ["VITO", "MERCEDES8", "MERCEDES"] },
// // // // // // //   { key: "TRANSPORTER", name: "Transporter", capacity: 6, img: IMG.TRANSPORTER, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
// // // // // // //   { key: "SPRINTER", name: "Sprinter (Minibus)", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER", "MINIBUS", "BUS"] },
// // // // // // // ];

// // // // // // // function findPriceKey(regionPrices, matchKeywords) {
// // // // // // //   if (!regionPrices) return null;
// // // // // // //   const upper = Object.keys(regionPrices).map((k) => [k, k.toUpperCase()]);
// // // // // // //   for (const kw of matchKeywords) {
// // // // // // //     const hit = upper.find(([, U]) => U.includes(kw));
// // // // // // //     if (hit) return hit[0];
// // // // // // //   }
// // // // // // //   return null;
// // // // // // // }

// // // // // // // const MobileTransferSearch = () => {
// // // // // // //   const navigate = useNavigate();
// // // // // // //   const { t } = useTranslation("searchbox");
// // // // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // // // //   // tarih/saat default
// // // // // // //   const todayISO = new Date().toISOString().split("T")[0];
// // // // // // //   const nextHour = (() => {
// // // // // // //     const d = new Date();
// // // // // // //     d.setMinutes(0, 0, 0);
// // // // // // //     d.setHours(d.getHours() + 1);
// // // // // // //     return d.toTimeString().slice(0, 5);
// // // // // // //   })();
// // // // // // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // // // // // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // // // // // //   // bölge opsiyonları
// // // // // // //   const regionOptions = useMemo(
// // // // // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // // // // //     [pricesByRegionAndVehicle]
// // // // // // //   );

// // // // // // //   // çift yön – fiyat tablosu bul
// // // // // // //   let regionKey = null;
// // // // // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
// // // // // // //   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
// // // // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // // // // //   // pax -> araç listesi
// // // // // // //   const pax = Number(passengerCount || 1);
// // // // // // //   const allowedVehicles = pax <= 6 ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] : [VEHICLES_ALL[2]];

// // // // // // //   // seçili araç
// // // // // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // // // // // //   useEffect(() => {
// // // // // // //     setSelectedVehicleKey(allowedVehicles[0].key);
// // // // // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // // // // //   }, [pax]);

// // // // // // //   // araç için fiyat
// // // // // // //   const priceForVehicle = (v) => {
// // // // // // //     if (!regionPrices) return null;
// // // // // // //     const k = findPriceKey(regionPrices, v.match) || v.key;
// // // // // // //     const raw = regionPrices[k];
// // // // // // //     return raw ? convertPrice(raw, i18n.language) : null;
// // // // // // //   };

// // // // // // //   const selectedVehicleDef = allowedVehicles.find((v) => v.key === selectedVehicleKey) || allowedVehicles[0];

// // // // // // //   const handleSearch = (e) => {
// // // // // // //     e.preventDefault();
// // // // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // // // // // //     navigate(
// // // // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // // // //         selectedTo
// // // // // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // // // // // //         selectedVehicleKey
// // // // // // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // // // // // //     );
// // // // // // //   };

// // // // // // //   const handleWhatsApp = () => {
// // // // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // // // // // //     const msg =
// // // // // // //       `Date: ${pickupDate}\n` +
// // // // // // //       `Time: ${pickupTime}\n\n` +
// // // // // // //       `From: ${selectedFrom}\n` +
// // // // // // //       `To: ${selectedTo}\n` +
// // // // // // //       `Persons: ${passengerCount}\n` +
// // // // // // //       `Car: ${selectedVehicleDef.name}\n\n` +
// // // // // // //       `ANTALYA VIP PICKUP`;
// // // // // // //     const phone = "9054668301";
// // // // // // //     const url = `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
// // // // // // //     window.open(url, "_blank");
// // // // // // //   };

// // // // // // //   return (
// // // // // // //     <div className="block md:hidden bg-black text-white pb-5 px-3 pt-2">
// // // // // // //       <form
// // // // // // //         onSubmit={handleSearch}
// // // // // // //         className="max-w-sm mx-auto bg-gray-900 rounded-2xl p-3 shadow-inner"
// // // // // // //       >
// // // // // // //         {/* Başlık */}
// // // // // // //         <h4 className="text-center text-[16px] font-semibold text-yellow-500 mb-2">
// // // // // // //           {t("quickReservation") || "Quick Reservation"}
// // // // // // //         </h4>

// // // // // // //         {/* === 2 SÜTUN GRID === */}
// // // // // // //         <div className="grid grid-cols-2 gap-2">
// // // // // // //           {/* From */}
// // // // // // //           <div className="col-span-1 bg-gray-800 rounded-lg px-3 py-2 flex items-center gap-2">
// // // // // // //             <FaMapMarkerAlt className="shrink-0" />
// // // // // // //             <select
// // // // // // //               value={selectedFrom}
// // // // // // //               onChange={(e) => setSelectedFrom(e.target.value)}
// // // // // // //               className="bg-transparent text-white w-full focus:outline-none text-[13px] h-[36px]"
// // // // // // //             >
// // // // // // //               {regionOptions.map((region, idx) => (
// // // // // // //                 <option key={idx} value={region} className="text-black">
// // // // // // //                   {region}
// // // // // // //                 </option>
// // // // // // //               ))}
// // // // // // //             </select>
// // // // // // //           </div>

// // // // // // //           {/* To */}
// // // // // // //           <div className="col-span-1 bg-gray-800 rounded-lg px-3 py-2 flex items-center gap-2">
// // // // // // //             <FaMapMarkerAlt className="shrink-0" />
// // // // // // //             <select
// // // // // // //               value={selectedTo}
// // // // // // //               onChange={(e) => setSelectedTo(e.target.value)}
// // // // // // //               className="bg-transparent text-white w-full focus:outline-none text-[13px] h-[36px]"
// // // // // // //             >
// // // // // // //               <option value="">{t("toPlaceholder") || "Select Drop-off"}</option>
// // // // // // //               {regionOptions
// // // // // // //                 .filter((region) => region !== selectedFrom)
// // // // // // //                 .map((region, idx) => (
// // // // // // //                   <option key={idx} value={region} className="text-black">
// // // // // // //                     {region}
// // // // // // //                   </option>
// // // // // // //                 ))}
// // // // // // //             </select>
// // // // // // //           </div>

// // // // // // //           {/* Vehicle Selection (tam genişlik) */}
// // // // // // //           <div className="col-span-2 bg-gray-800 rounded-lg p-2">
// // // // // // //             <div className="text-[12px] text-gray-300 mb-1">
// // // // // // //               {t("vehicleSelection") || "Vehicle Selection"}
// // // // // // //             </div>
// // // // // // //             <div className="grid grid-cols-2 gap-2">
// // // // // // //               {allowedVehicles.map((v) => {
// // // // // // //                 const active = v.key === selectedVehicleKey;
// // // // // // //                 const price = priceForVehicle(v);
// // // // // // //                 return (
// // // // // // //                   <button
// // // // // // //                     type="button"
// // // // // // //                     key={v.key}
// // // // // // //                     onClick={() => setSelectedVehicleKey(v.key)}
// // // // // // //                     className={`w-full flex items-center gap-2 rounded-md border px-2 py-2 text-left ${
// // // // // // //                       active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // // // // //                     }`}
// // // // // // //                   >
// // // // // // //                     <img src={v.img} alt={v.name} className="w-12 h-10 object-contain" />
// // // // // // //                     <div className="flex-1">
// // // // // // //                       <div className="text-white text-[13px] font-medium leading-tight">
// // // // // // //                         {v.name}
// // // // // // //                       </div>
// // // // // // //                       <div className="text-[11px] text-gray-400 leading-tight">
// // // // // // //                         {(t("passengers") || "Passengers")}: {v.capacity}
// // // // // // //                       </div>
// // // // // // //                     </div>
// // // // // // //                     {price && (
// // // // // // //                       <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
// // // // // // //                         {price}
// // // // // // //                       </div>
// // // // // // //                     )}
// // // // // // //                   </button>
// // // // // // //                 );
// // // // // // //               })}
// // // // // // //             </div>

// // // // // // //             {/* seçili araç özeti */}
// // // // // // //             <div className="text-[11px] text-gray-300 mt-1">
// // // // // // //               {(t("vehicleSelection") || "Vehicle")}: {selectedVehicleDef.name}
// // // // // // //               {regionPrices && priceForVehicle(selectedVehicleDef)
// // // // // // //                 ? ` • ${priceForVehicle(selectedVehicleDef)}`
// // // // // // //                 : ""}
// // // // // // //             </div>
// // // // // // //           </div>

// // // // // // //           {/* Pickup Date */}
// // // // // // //           <div className="col-span-1 bg-gray-800 rounded-lg px-3 py-2">
// // // // // // //             <div className="text-[11px] text-gray-300 mb-1">
// // // // // // //               {t("pickupDate") || "Pickup Date"}
// // // // // // //             </div>
// // // // // // //             <input
// // // // // // //               type="date"
// // // // // // //               value={pickupDate}
// // // // // // //               onChange={(e) => setPickupDate(e.target.value)}
// // // // // // //               className="w-full bg-transparent text-white focus:outline-none text-[13px] h-[36px]"
// // // // // // //             />
// // // // // // //           </div>

// // // // // // //           {/* Pickup Time */}
// // // // // // //           <div className="col-span-1 bg-gray-800 rounded-lg px-3 py-2">
// // // // // // //             <div className="text-[11px] text-gray-300 mb-1">
// // // // // // //               {t("pickupTime") || "Pickup Time"}
// // // // // // //             </div>
// // // // // // //             <input
// // // // // // //               type="time"
// // // // // // //               value={pickupTime}
// // // // // // //               onChange={(e) => setPickupTime(e.target.value)}
// // // // // // //               className="w-full bg-transparent text-white focus:outline-none text-[13px] h-[36px]"
// // // // // // //             />
// // // // // // //           </div>

// // // // // // //           {/* Passengers */}
// // // // // // //           <div className="col-span-1 bg-gray-800 rounded-lg px-3 py-2 flex items-center gap-2">
// // // // // // //             <FaUsers className="shrink-0" />
// // // // // // //             <select
// // // // // // //               value={passengerCount}
// // // // // // //               onChange={(e) => setPassengerCount(e.target.value)}
// // // // // // //               className="bg-transparent text-white w-full focus:outline-none text-[13px] h-[36px]"
// // // // // // //             >
// // // // // // //               {[...Array(14)].map((_, i) => (
// // // // // // //                 <option key={i + 1} value={i + 1} className="text-black">
// // // // // // //                   {(t("passengers") || "Passengers")}: {i + 1}
// // // // // // //                 </option>
// // // // // // //               ))}
// // // // // // //             </select>
// // // // // // //           </div>

// // // // // // //           {/* WhatsApp (tam genişlik) */}
// // // // // // //           <div className="col-span-2">
// // // // // // //             <button
// // // // // // //               type="button"
// // // // // // //               onClick={handleWhatsApp}
// // // // // // //               className="w-full flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg h-[40px] transition"
// // // // // // //             >
// // // // // // //               <FaWhatsapp /> Get a Price on WhatsApp
// // // // // // //             </button>
// // // // // // //           </div>

// // // // // // //           {/* Search (tam genişlik) */}
// // // // // // //           <div className="col-span-2">
// // // // // // //             <button
// // // // // // //               type="submit"
// // // // // // //               className="w-full flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-black font-semibold rounded-lg h-[40px] transition"
// // // // // // //             >
// // // // // // //               <FaSearch /> {t("search")}
// // // // // // //             </button>
// // // // // // //           </div>
// // // // // // //         </div>
// // // // // // //       </form>

// // // // // // //       {/* compact tweaks */}
// // // // // // //       <style>{`
// // // // // // //         @media (max-width: 480px) {
// // // // // // //           .no-scrollbar::-webkit-scrollbar{ display:none; }
// // // // // // //           .no-scrollbar{ -ms-overflow-style:none; scrollbar-width:none; }
// // // // // // //         }
// // // // // // //       `}</style>
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileTransferSearch;
// // // // // // import React, { useMemo, useState, useEffect } from "react";
// // // // // // import { useNavigate } from "react-router-dom";
// // // // // // import { useTranslation } from "react-i18next";
// // // // // // import { usePriceData } from "../context/PriceContext";
// // // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // // import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
// // // // // // import i18n from "i18next";

// // // // // // const IMG = {
// // // // // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // // // // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // // // // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // // // // };

// // // // // // const VEHICLES_ALL = [
// // // // // //   { key: "MERCEDES8", name: "Mercedes Vito",      capacity: 6,  img: IMG.MERCEDES8,  match: ["VITO","MERCEDES8","MERCEDES"] },
// // // // // //   { key: "TRANSPORTER", name: "Transporter",       capacity: 6,  img: IMG.TRANSPORTER, match: ["TRANSPORTER","TRANS","CARAVELLE"] },
// // // // // //   { key: "SPRINTER",    name: "Sprinter (Minibus)",capacity: 13, img: IMG.SPRINTER,   match: ["SPRINTER","MINIBUS","BUS"] },
// // // // // // ];

// // // // // // function findPriceKey(regionPrices, matchKeywords) {
// // // // // //   if (!regionPrices) return null;
// // // // // //   const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
// // // // // //   for (const kw of matchKeywords) {
// // // // // //     const hit = upper.find(([, U]) => U.includes(kw));
// // // // // //     if (hit) return hit[0];
// // // // // //   }
// // // // // //   return null;
// // // // // // }

// // // // // // export default function MobileTransferSearch() {
// // // // // //   const navigate = useNavigate();
// // // // // //   const { t } = useTranslation("searchbox");
// // // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // // //   const todayISO = new Date().toISOString().split("T")[0];
// // // // // //   const nextHour = (() => {
// // // // // //     const d = new Date();
// // // // // //     d.setMinutes(0,0,0); d.setHours(d.getHours()+1);
// // // // // //     return d.toTimeString().slice(0,5);
// // // // // //   })();
// // // // // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // // // // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // // // // //   const regionOptions = useMemo(
// // // // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // // // //     [pricesByRegionAndVehicle]
// // // // // //   );

// // // // // //   let regionKey = null;
// // // // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
// // // // // //   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
// // // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // // // //   const pax = Number(passengerCount || 1);
// // // // // //   const allowedVehicles = pax <= 6 ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] : [VEHICLES_ALL[2]];

// // // // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // // // // //   useEffect(() => { setSelectedVehicleKey(allowedVehicles[0].key); }, [pax]); // eslint-disable-line

// // // // // //   const priceForVehicle = (v) => {
// // // // // //     if (!regionPrices) return null;
// // // // // //     const k = findPriceKey(regionPrices, v.match) || v.key;
// // // // // //     const raw = regionPrices[k];
// // // // // //     return raw ? convertPrice(raw, i18n.language) : null;
// // // // // //   };

// // // // // //   const selectedVehicleDef =
// // // // // //     allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

// // // // // //   const handleSearch = (e) => {
// // // // // //     e.preventDefault();
// // // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // // // // //     navigate(
// // // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // // //         selectedTo
// // // // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // // // // //         selectedVehicleKey
// // // // // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // // // // //     );
// // // // // //   };

// // // // // //   const handleWhatsApp = () => {
// // // // // //     if (!selectedFrom || !selectedTo) return;
// // // // // //     const msg =
// // // // // //       `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
// // // // // //       `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
// // // // // //       `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
// // // // // //       `ANTALYA VIP TRANSFER`;
// // // // // //     const phone = "9054668301";
// // // // // //     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
// // // // // //   };

// // // // // //   return (
// // // // // //     <div className="md:hidden text-white">
// // // // // //       {/* KISA/KOMPAKT KART — %95 genişlik, küçük padding */}
// // // // // //       <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
// // // // // //         <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
// // // // // //           {t("quickReservation") || "Quick Reservation"}
// // // // // //         </h4>

// // // // // //         {/* FORM (kompakt aralıklar) */}
// // // // // //         <form onSubmit={handleSearch}>
// // // // // //           <div className="grid grid-cols-2 gap-x-2 gap-y-2">
// // // // // //             {/* From */}
// // // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1.5 rounded-md flex items-center gap-1.5">
// // // // // //               <FaMapMarkerAlt className="shrink-0" />
// // // // // //               <select
// // // // // //                 value={selectedFrom}
// // // // // //                 onChange={(e) => setSelectedFrom(e.target.value)}
// // // // // //                 className="bg-transparent text-white w-full focus:outline-none text-[12px] h-[30px]"
// // // // // //               >
// // // // // //                 {regionOptions.map((r, i) => (
// // // // // //                   <option key={i} value={r} className="text-black text-[12px]">{r}</option>
// // // // // //                 ))}
// // // // // //               </select>
// // // // // //             </div>

// // // // // //             {/* To */}
// // // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1.5 rounded-md flex items-center gap-1.5">
// // // // // //               <FaMapMarkerAlt className="shrink-0" />
// // // // // //               <select
// // // // // //                 value={selectedTo}
// // // // // //                 onChange={(e) => setSelectedTo(e.target.value)}
// // // // // //                 className="bg-transparent text-white w-full focus:outline-none text-[12px] h-[30px]"
// // // // // //               >
// // // // // //                 <option value="">{t("toPlaceholder") || "Select Drop-off Location"}</option>
// // // // // //                 {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
// // // // // //                   <option key={i} value={r} className="text-black text-[12px]">{r}</option>
// // // // // //                 ))}
// // // // // //               </select>
// // // // // //             </div>

// // // // // //             {/* Vehicle (ince çipler) */}
// // // // // //             <div className="col-span-2 bg-gray-800 rounded-md p-1.5">
// // // // // //               <div className="text-[11px] text-gray-300 mb-1">
// // // // // //                 {t("vehicleSelection") || "Vehicle Selection"}
// // // // // //               </div>
// // // // // //               <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
// // // // // //                 {allowedVehicles.map((v) => {
// // // // // //                   const active = v.key === selectedVehicleKey;
// // // // // //                   const price = priceForVehicle(v);
// // // // // //                   return (
// // // // // //                     <button
// // // // // //                       type="button"
// // // // // //                       key={v.key}
// // // // // //                       onClick={() => setSelectedVehicleKey(v.key)}
// // // // // //                       className={`min-w-[150px] flex items-center gap-2 rounded border px-2 py-1.5 text-left text-[12px] ${
// // // // // //                         active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // // // //                       }`}
// // // // // //                     >
// // // // // //                       <img src={v.img} alt={v.name} className="w-10 h-8 object-contain" />
// // // // // //                       <div className="flex-1">
// // // // // //                         <div className="text-white font-medium leading-none">{v.name}</div>
// // // // // //                         <div className="text-[11px] text-gray-400 leading-none mt-0.5">
// // // // // //                           {t("passengers") || "Passengers"}: {v.capacity}
// // // // // //                         </div>
// // // // // //                       </div>
// // // // // //                       {price && (
// // // // // //                         <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
// // // // // //                           {price}
// // // // // //                         </div>
// // // // // //                       )}
// // // // // //                     </button>
// // // // // //                   );
// // // // // //                 })}
// // // // // //               </div>
// // // // // //             </div>

// // // // // //             {/* Date */}
// // // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1.5 rounded-md">
// // // // // //               <div className="text-[11px] text-gray-300 mb-0.5">{t("pickupDate") || "Pickup Date"}</div>
// // // // // //               <input
// // // // // //                 type="date"
// // // // // //                 value={pickupDate}
// // // // // //                 onChange={(e) => setPickupDate(e.target.value)}
// // // // // //                 className="w-full bg-transparent text-white focus:outline-none text-[12px] h-[30px]"
// // // // // //               />
// // // // // //             </div>

// // // // // //             {/* Time */}
// // // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1.5 rounded-md">
// // // // // //               <div className="text-[11px] text-gray-300 mb-0.5">{t("pickupTime") || "Pickup Time"}</div>
// // // // // //               <input
// // // // // //                 type="time"
// // // // // //                 value={pickupTime}
// // // // // //                 onChange={(e) => setPickupTime(e.target.value)}
// // // // // //                 className="w-full bg-transparent text-white focus:outline-none text-[12px] h-[30px]"
// // // // // //               />
// // // // // //             </div>

// // // // // //             {/* Passengers */}
// // // // // //             <div className="col-span-2 bg-gray-800 px-2 py-1.5 rounded-md flex items-center gap-1.5">
// // // // // //               <FaUsers className="shrink-0" />
// // // // // //               <select
// // // // // //                 value={passengerCount}
// // // // // //                 onChange={(e) => setPassengerCount(e.target.value)}
// // // // // //                 className="bg-transparent text-white w-full focus:outline-none text-[12px] h-[30px]"
// // // // // //               >
// // // // // //                 {[...Array(14)].map((_, i) => (
// // // // // //                   <option key={i + 1} value={i + 1} className="text-black text-[12px]">
// // // // // //                     {t("passengers") || "Passengers"}: {i + 1}
// // // // // //                   </option>
// // // // // //                 ))}
// // // // // //               </select>
// // // // // //             </div>
// // // // // //           </div>

// // // // // //           {/* WhatsApp — sabit değil; kartı uzatmaz */}
// // // // // //           <div className="mt-2 flex justify-center">
// // // // // //             <button
// // // // // //               type="button"
// // // // // //               onClick={handleWhatsApp}
// // // // // //               className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
// // // // // //             >
// // // // // //               <FaWhatsapp /> Get a Price on WhatsApp
// // // // // //             </button>
// // // // // //           </div>
// // // // // //         </form>
// // // // // //       </div>

// // // // // //       <style>{`
// // // // // //         .no-scrollbar::-webkit-scrollbar { display: none; }
// // // // // //         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
// // // // // //       `}</style>
// // // // // //     </div>
// // // // // //   );
// // // // // // }
// // // // // import React, { useMemo, useState, useEffect } from "react";
// // // // // import { useNavigate } from "react-router-dom";
// // // // // import { useTranslation } from "react-i18next";
// // // // // import { usePriceData } from "../context/PriceContext";
// // // // // import { convertPrice } from "../utils/currencyRates";
// // // // // import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
// // // // // import i18n from "i18next";

// // // // // const IMG = {
// // // // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // // // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // // // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // // // };

// // // // // const VEHICLES_ALL = [
// // // // //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6,  img: IMG.MERCEDES8,  match: ["VITO", "MERCEDES8", "MERCEDES"] },
// // // // //   { key: "TRANSPORTER", name: "Transporter",  capacity: 6,  img: IMG.TRANSPORTER, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
// // // // //   { key: "SPRINTER", name: "Sprinter (Minibus)", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER", "MINIBUS", "BUS"] },
// // // // // ];

// // // // // function findPriceKey(regionPrices, matchKeywords) {
// // // // //   if (!regionPrices) return null;
// // // // //   const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
// // // // //   for (const kw of matchKeywords) {
// // // // //     const hit = upper.find(([, U]) => U.includes(kw));
// // // // //     if (hit) return hit[0];
// // // // //   }
// // // // //   return null;
// // // // // }

// // // // // export default function MobileTransferSearch() {
// // // // //   const navigate = useNavigate();
// // // // //   const { t } = useTranslation("searchbox");
// // // // //   const pricesByRegionAndVehicle = usePriceData();

// // // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // // //   const [selectedTo, setSelectedTo] = useState("");
// // // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // // //   const todayISO = new Date().toISOString().split("T")[0];
// // // // //   const nextHour = (() => {
// // // // //     const d = new Date();
// // // // //     d.setMinutes(0, 0, 0);
// // // // //     d.setHours(d.getHours() + 1);
// // // // //     return d.toTimeString().slice(0, 5);
// // // // //   })();
// // // // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // // // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // // // //   const regionOptions = useMemo(
// // // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // // //     [pricesByRegionAndVehicle]
// // // // //   );

// // // // //   let regionKey = null;
// // // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
// // // // //   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
// // // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // // //   const pax = Number(passengerCount || 1);
// // // // //   const allowedVehicles = pax <= 6 ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] : [VEHICLES_ALL[2]];

// // // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // // // //   useEffect(() => { setSelectedVehicleKey(allowedVehicles[0].key); }, [pax]); // eslint-disable-line

// // // // //   const priceForVehicle = (v) => {
// // // // //     if (!regionPrices) return null;
// // // // //     const k = findPriceKey(regionPrices, v.match) || v.key;
// // // // //     const raw = regionPrices[k];
// // // // //     return raw ? convertPrice(raw, i18n.language) : null;
// // // // //   };

// // // // //   const selectedVehicleDef =
// // // // //     allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

// // // // //   const handleSearch = (e) => {
// // // // //     e.preventDefault();
// // // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // // // //     navigate(
// // // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // // //         selectedTo
// // // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // // // //         selectedVehicleKey
// // // // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // // // //     );
// // // // //   };

// // // // //   const handleWhatsApp = () => {
// // // // //     if (!selectedFrom || !selectedTo) return;
// // // // //     const msg =
// // // // //       `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
// // // // //       `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
// // // // //       `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
// // // // //       `ANTALYA VIP TRANSFER`;
// // // // //     const phone = "9054668301";
// // // // //     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
// // // // //   };

// // // // //   return (
// // // // //     <div className="md:hidden text-white">
// // // // //       {/* KISA/KOMPAKT KART — %95 genişlik, küçültülmüş kontroller */}
// // // // //       <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
// // // // //         <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
// // // // //           {t("quickReservation") || "Quick Reservation"}
// // // // //         </h4>

// // // // //         {/* FORM */}
// // // // //         <form onSubmit={handleSearch}>
// // // // //           <div className="grid grid-cols-2 gap-x-2 gap-y-2">
// // // // //             {/* From */}
// // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // // // //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// // // // //               <select
// // // // //                 value={selectedFrom}
// // // // //                 onChange={(e) => setSelectedFrom(e.target.value)}
// // // // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // // // //               >
// // // // //                 {regionOptions.map((r, i) => (
// // // // //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// // // // //                 ))}
// // // // //               </select>
// // // // //             </div>

// // // // //             {/* To */}
// // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // // // //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// // // // //               <select
// // // // //                 value={selectedTo}
// // // // //                 onChange={(e) => setSelectedTo(e.target.value)}
// // // // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // // // //               >
// // // // //                 <option value="">{t("toPlaceholder") || "Select Drop-off Location"}</option>
// // // // //                 {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
// // // // //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// // // // //                 ))}
// // // // //               </select>
// // // // //             </div>

// // // // //             {/* Vehicle (ince çipler) */}
// // // // //             <div className="col-span-2 bg-gray-800 rounded-md p-1.5">
// // // // //               <div className="text-[11px] text-gray-300 mb-1">
// // // // //                 {t("vehicleSelection") || "Vehicle Selection"}
// // // // //               </div>
// // // // //               <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
// // // // //                 {allowedVehicles.map((v) => {
// // // // //                   const active = v.key === selectedVehicleKey;
// // // // //                   const price = priceForVehicle(v);
// // // // //                   return (
// // // // //                     <button
// // // // //                       type="button"
// // // // //                       key={v.key}
// // // // //                       onClick={() => setSelectedVehicleKey(v.key)}
// // // // //                       className={`min-w-[150px] flex items-center gap-2 rounded border px-2 py-1.5 text-left text-[12px] ${
// // // // //                         active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // // //                       }`}
// // // // //                     >
// // // // //                       <img src={v.img} alt={v.name} className="w-10 h-8 object-contain" />
// // // // //                       <div className="flex-1">
// // // // //                         <div className="text-white font-medium leading-none">{v.name}</div>
// // // // //                         <div className="text-[11px] text-gray-400 leading-none mt-0.5">
// // // // //                           {t("passengers") || "Passengers"}: {v.capacity}
// // // // //                         </div>
// // // // //                       </div>
// // // // //                       {price && (
// // // // //                         <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
// // // // //                           {price}
// // // // //                         </div>
// // // // //                       )}
// // // // //                     </button>
// // // // //                   );
// // // // //                 })}
// // // // //               </div>
// // // // //             </div>

// // // // //             {/* Date */}
// // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// // // // //               <div className="text-[10px] text-gray-300 mb-0.5">{t("pickupDate") || "Pickup Date"}</div>
// // // // //               <input
// // // // //                 type="date"
// // // // //                 value={pickupDate}
// // // // //                 onChange={(e) => setPickupDate(e.target.value)}
// // // // //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// // // // //               />
// // // // //             </div>

// // // // //             {/* Time */}
// // // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// // // // //               <div className="text-[10px] text-gray-300 mb-0.5">{t("pickupTime") || "Pickup Time"}</div>
// // // // //               <input
// // // // //                 type="time"
// // // // //                 value={pickupTime}
// // // // //                 onChange={(e) => setPickupTime(e.target.value)}
// // // // //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// // // // //               />
// // // // //             </div>

// // // // //             {/* Passengers */}
// // // // //             <div className="col-span-2 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // // // //               <FaUsers className="shrink-0 text-[12px]" />
// // // // //               <select
// // // // //                 value={passengerCount}
// // // // //                 onChange={(e) => setPassengerCount(e.target.value)}
// // // // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // // // //               >
// // // // //                 {[...Array(14)].map((_, i) => (
// // // // //                   <option key={i + 1} value={i + 1} className="text-black text-[11px]">
// // // // //                     {t("passengers") || "Passengers"}: {i + 1}
// // // // //                   </option>
// // // // //                 ))}
// // // // //               </select>
// // // // //             </div>
// // // // //           </div>

// // // // //           {/* WhatsApp — sabit değil; kartı uzatmaz */}
// // // // //           <div className="mt-2 flex justify-center">
// // // // //             <button
// // // // //               type="button"
// // // // //               onClick={handleWhatsApp}
// // // // //               className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
// // // // //             >
// // // // //               <FaWhatsapp /> Get a Price on WhatsApp
// // // // //             </button>
// // // // //           </div>
// // // // //         </form>
// // // // //       </div>

// // // // //       <style>{`
// // // // //         .no-scrollbar::-webkit-scrollbar { display: none; }
// // // // //         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
// // // // //       `}</style>
// // // // //     </div>
// // // // //   );
// // // // // }
// // // // import React, { useMemo, useState, useEffect } from "react";
// // // // import { useNavigate } from "react-router-dom";
// // // // import { useTranslation } from "react-i18next";
// // // // import { usePriceData } from "../context/PriceContext";
// // // // import { convertPrice } from "../utils/currencyRates";
// // // // import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
// // // // import i18n from "i18next";

// // // // const IMG = {
// // // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // // };

// // // // const VEHICLES_ALL = [
// // // //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6, img: IMG.MERCEDES8, match: ["VITO","MERCEDES8","MERCEDES"] },
// // // //   { key: "TRANSPORTER", name: "Transporter",  capacity: 6, img: IMG.TRANSPORTER, match: ["TRANSPORTER","TRANS","CARAVELLE"] },
// // // //   { key: "SPRINTER",    name: "Sprinter (Minibus)", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER","MINIBUS","BUS"] },
// // // // ];

// // // // function findPriceKey(regionPrices, matchKeywords) {
// // // //   if (!regionPrices) return null;
// // // //   const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
// // // //   for (const kw of matchKeywords) {
// // // //     const hit = upper.find(([, U]) => U.includes(kw));
// // // //     if (hit) return hit[0];
// // // //   }
// // // //   return null;
// // // // }

// // // // export default function MobileTransferSearch() {
// // // //   const navigate = useNavigate();
// // // //   const { t } = useTranslation("searchbox");
// // // //   const pricesByRegionAndVehicle = usePriceData();

// // // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // // //   const [selectedTo, setSelectedTo] = useState("");
// // // //   const [passengerCount, setPassengerCount] = useState("1");

// // // //   const todayISO = new Date().toISOString().split("T")[0];
// // // //   const nextHour = (() => {
// // // //     const d = new Date();
// // // //     d.setMinutes(0,0,0); d.setHours(d.getHours()+1);
// // // //     return d.toTimeString().slice(0,5);
// // // //   })();
// // // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // // //   const regionOptions = useMemo(
// // // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // // //     [pricesByRegionAndVehicle]
// // // //   );

// // // //   let regionKey = null;
// // // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
// // // //   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
// // // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // // //   const pax = Number(passengerCount || 1);
// // // //   const allowedVehicles = pax <= 6 ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] : [VEHICLES_ALL[2]];

// // // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // // //   useEffect(() => { setSelectedVehicleKey(allowedVehicles[0].key); }, [pax]); // eslint-disable-line

// // // //   const priceForVehicle = (v) => {
// // // //     if (!regionPrices) return null;
// // // //     const k = findPriceKey(regionPrices, v.match) || v.key;
// // // //     const raw = regionPrices[k];
// // // //     return raw ? convertPrice(raw, i18n.language) : null;
// // // //   };

// // // //   const selectedVehicleDef =
// // // //     allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

// // // //   const handleSearch = (e) => {
// // // //     e.preventDefault();
// // // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // // //     navigate(
// // // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // // //         selectedTo
// // // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // // //         selectedVehicleKey
// // // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // // //     );
// // // //   };

// // // //   const handleWhatsApp = () => {
// // // //     if (!selectedFrom || !selectedTo) return;
// // // //     const msg =
// // // //       `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
// // // //       `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
// // // //       `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
// // // //       `ANTALYA VIP TRANSFER`;
// // // //     const phone = "9054668301";
// // // //     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
// // // //   };

// // // //   return (
// // // //     <div className="md:hidden text-white">
// // // //       {/* Kısa/kompakt kart */}
// // // //       <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
// // // //         <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
// // // //           {t("quickReservation") || "Quick Reservation"}
// // // //         </h4>

// // // //         <form onSubmit={handleSearch}>
// // // //           <div className="grid grid-cols-2 gap-x-2 gap-y-2">
// // // //             {/* From */}
// // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // // //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// // // //               <select
// // // //                 value={selectedFrom}
// // // //                 onChange={(e) => setSelectedFrom(e.target.value)}
// // // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // // //               >
// // // //                 {regionOptions.map((r, i) => (
// // // //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// // // //                 ))}
// // // //               </select>
// // // //             </div>

// // // //             {/* To */}
// // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // // //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// // // //               <select
// // // //                 value={selectedTo}
// // // //                 onChange={(e) => setSelectedTo(e.target.value)}
// // // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // // //               >
// // // //                 <option value="">{t("toPlaceholder") || "Select Drop-off Location"}</option>
// // // //                 {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
// // // //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// // // //                 ))}
// // // //               </select>
// // // //             </div>

// // // //             {/* Vehicle */}
// // // //             <div className="col-span-2 bg-gray-800 rounded-md p-1.5">
// // // //               <div className="text-[11px] text-gray-300 mb-1">
// // // //                 {t("vehicleSelection") || "Vehicle Selection"}
// // // //               </div>
// // // //               <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
// // // //                 {allowedVehicles.map((v) => {
// // // //                   const active = v.key === selectedVehicleKey;
// // // //                   const price = priceForVehicle(v);
// // // //                   return (
// // // //                     <button
// // // //                       type="button"
// // // //                       key={v.key}
// // // //                       onClick={() => setSelectedVehicleKey(v.key)}
// // // //                       className={`min-w-[150px] flex items-center gap-2 rounded border px-2 py-1.5 text-left text-[12px] ${
// // // //                         active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // // //                       }`}
// // // //                     >
// // // //                       <img src={v.img} alt={v.name} className="w-10 h-8 object-contain" />
// // // //                       <div className="flex-1">
// // // //                         <div className="text-white font-medium leading-none">{v.name}</div>
// // // //                         <div className="text-[11px] text-gray-400 leading-none mt-0.5">
// // // //                           {(t("passengers") || "Passengers")}: {v.capacity}
// // // //                         </div>
// // // //                       </div>
// // // //                       {price && (
// // // //                         <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
// // // //                           {price}
// // // //                         </div>
// // // //                       )}
// // // //                     </button>
// // // //                   );
// // // //                 })}
// // // //               </div>
// // // //             </div>

// // // //             {/* Date */}
// // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// // // //               <div className="text-[10px] text-gray-300 mb-0.5">
// // // //                 {t("pickupDate") || "Pickup Date"}
// // // //               </div>
// // // //               <input
// // // //                 type="date"
// // // //                 value={pickupDate}
// // // //                 onChange={(e) => setPickupDate(e.target.value)}
// // // //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// // // //               />
// // // //             </div>

// // // //             {/* Time */}
// // // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// // // //               <div className="text-[10px] text-gray-300 mb-0.5">
// // // //                 {t("pickupTime") || "Pickup Time"}
// // // //               </div>
// // // //               <input
// // // //                 type="time"
// // // //                 value={pickupTime}
// // // //                 onChange={(e) => setPickupTime(e.target.value)}
// // // //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// // // //               />
// // // //             </div>

// // // //             {/* Passengers */}
// // // //             <div className="col-span-2 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // // //               <FaUsers className="shrink-0 text-[12px]" />
// // // //               <select
// // // //                 value={passengerCount}
// // // //                 onChange={(e) => setPassengerCount(e.target.value)}
// // // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // // //               >
// // // //                 {[...Array(14)].map((_, i) => (
// // // //                   <option key={i + 1} value={i + 1} className="text-black text-[11px]">
// // // //                     {(t("passengers") || "Passengers")}: {i + 1}
// // // //                   </option>
// // // //                 ))}
// // // //               </select>
// // // //             </div>
// // // //           </div>

// // // //           {/* WhatsApp */}
// // // //           <div className="mt-2 flex justify-center">
// // // //             <button
// // // //               type="button"
// // // //               onClick={handleWhatsApp}
// // // //               className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
// // // //             >
// // // //               <FaWhatsapp /> {t("whatsappCta") || "Get a Price on WhatsApp"}
// // // //             </button>
// // // //           </div>
// // // //         </form>
// // // //       </div>

// // // //       <style>{`
// // // //         .no-scrollbar::-webkit-scrollbar { display: none; }
// // // //         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
// // // //       `}</style>
// // // //     </div>
// // // //   );
// // // // }
// // // // // 
// // // import React, { useMemo, useState, useEffect } from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import { useTranslation } from "react-i18next";
// // // import { usePriceData } from "../context/PriceContext";
// // // import { convertPrice } from "../utils/currencyRates";
// // // import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
// // // import i18n from "i18next";

// // // const IMG = {
// // //   MERCEDES8: "/images/vehicles/mercedes8.png",
// // //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// // //   SPRINTER: "/images/vehicles/sprinter.png",
// // // };

// // // const VEHICLES_ALL = [
// // //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6,  img: IMG.MERCEDES8,  match: ["VITO", "MERCEDES8", "MERCEDES"] },
// // //   { key: "TRANSPORTER", name: "Transporter",  capacity: 6,  img: IMG.TRANSPORTER, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
// // //   { key: "SPRINTER", name: "Sprinter (Minibus)", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER", "MINIBUS", "BUS"] },
// // // ];

// // // function findPriceKey(regionPrices, matchKeywords) {
// // //   if (!regionPrices) return null;
// // //   const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
// // //   for (const kw of matchKeywords) {
// // //     const hit = upper.find(([, U]) => U.includes(kw));
// // //     if (hit) return hit[0];
// // //   }
// // //   return null;
// // // }

// // // // === i18n Title-Case helper ===
// // // function toTitleCase(s) {
// // //   return s
// // //     .replace(/[_-]/g, " ")
// // //     .replace(/([a-z])([A-Z])/g, "$1 $2")
// // //     .replace(/\s+/g, " ")
// // //     .trim()
// // //     .replace(/(^|\s)\S/g, (c) => c.toUpperCase());
// // // }
// // // function useTc(ns) {
// // //   const { t } = useTranslation(ns);
// // //   return (key, fallback) => {
// // //     const raw = t(key, { defaultValue: fallback });
// // //     // i18next bazen key'i döndürür; ya da deger lowercase/camelCase olabilir
// // //     if (!raw || raw === key) return fallback;
// // //     return toTitleCase(raw);
// // //   };
// // // }

// // // export default function MobileTransferSearch() {
// // //   const navigate = useNavigate();
// // //   const tc = useTc("searchbox");
// // //   const pricesByRegionAndVehicle = usePriceData();

// // //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// // //   const [selectedTo, setSelectedTo] = useState("");
// // //   const [passengerCount, setPassengerCount] = useState("1");

// // //   const todayISO = new Date().toISOString().split("T")[0];
// // //   const nextHour = (() => {
// // //     const d = new Date();
// // //     d.setMinutes(0, 0, 0);
// // //     d.setHours(d.getHours() + 1);
// // //     return d.toTimeString().slice(0, 5);
// // //   })();
// // //   const [pickupDate, setPickupDate] = useState(todayISO);
// // //   const [pickupTime, setPickupTime] = useState(nextHour);

// // //   const regionOptions = useMemo(
// // //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// // //     [pricesByRegionAndVehicle]
// // //   );

// // //   let regionKey = null;
// // //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
// // //   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
// // //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// // //   const pax = Number(passengerCount || 1);
// // //   const allowedVehicles = pax <= 6 ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] : [VEHICLES_ALL[2]];

// // //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// // //   useEffect(() => { setSelectedVehicleKey(allowedVehicles[0].key); }, [pax]); // eslint-disable-line

// // //   const priceForVehicle = (v) => {
// // //     if (!regionPrices) return null;
// // //     const k = findPriceKey(regionPrices, v.match) || v.key;
// // //     const raw = regionPrices[k];
// // //     return raw ? convertPrice(raw, i18n.language) : null;
// // //   };

// // //   const selectedVehicleDef =
// // //     allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

// // //   const handleSearch = (e) => {
// // //     e.preventDefault();
// // //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// // //     navigate(
// // //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// // //         selectedTo
// // //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// // //         selectedVehicleKey
// // //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// // //     );
// // //   };

// // //   const handleWhatsApp = () => {
// // //     if (!selectedFrom || !selectedTo) return;
// // //     const msg =
// // //       `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
// // //       `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
// // //       `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
// // //       `ANTALYA VIP TRANSFER`;
// // //     const phone = "905466830127";
// // //     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
// // //   };

// // //   return (
// // //     <div className="md:hidden text-white">
// // //       {/* Kart */}
// // //       <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
// // //         <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
// // //           {tc("quickReservation", "Quick Reservation")}
// // //         </h4>

// // //         <form onSubmit={handleSearch}>
// // //           <div className="grid grid-cols-2 gap-x-2 gap-y-2">
// // //             {/* From */}
// // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// // //               <select
// // //                 value={selectedFrom}
// // //                 onChange={(e) => setSelectedFrom(e.target.value)}
// // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // //               >
// // //                 {regionOptions.map((r, i) => (
// // //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// // //                 ))}
// // //               </select>
// // //             </div>

// // //             {/* To */}
// // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// // //               <select
// // //                 value={selectedTo}
// // //                 onChange={(e) => setSelectedTo(e.target.value)}
// // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // //               >
// // //                 <option value="">{tc("toPlaceholder", "Select Drop-off Location")}</option>
// // //                 {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
// // //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// // //                 ))}
// // //               </select>
// // //             </div>

// // //             {/* Vehicle */}
// // //             <div className="col-span-2 bg-gray-800 rounded-md p-1.5">
// // //               <div className="text-[11px] text-gray-300 mb-1">
// // //                 {tc("vehicleSelection", "Vehicle Selection")}
// // //               </div>
// // //               <div className="flex gap-1.5 overflow-x-auto no-scrollbar">
// // //                 {allowedVehicles.map((v) => {
// // //                   const active = v.key === selectedVehicleKey;
// // //                   const price = priceForVehicle(v);
// // //                   return (
// // //                     <button
// // //                       type="button"
// // //                       key={v.key}
// // //                       onClick={() => setSelectedVehicleKey(v.key)}
// // //                       className={`min-w-[150px] flex items-center gap-2 rounded border px-2 py-1.5 text-left text-[12px] ${
// // //                         active ? "border-yellow-500 bg-gray-700" : "border-gray-600 bg-gray-900"
// // //                       }`}
// // //                     >
// // //                       <img src={v.img} alt={v.name} className="w-10 h-8 object-contain" />
// // //                       <div className="flex-1">
// // //                         <div className="text-white font-medium leading-none">{v.name}</div>
// // //                         <div className="text-[11px] text-gray-400 leading-none mt-0.5">
// // //                           {tc("passengers", "Passengers")}: {v.capacity}
// // //                         </div>
// // //                       </div>
// // //                       {price && (
// // //                         <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
// // //                           {price}
// // //                         </div>
// // //                       )}
// // //                     </button>
// // //                   );
// // //                 })}
// // //               </div>
// // //             </div>

// // //             {/* Date */}
// // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// // //               <div className="text-[10px] text-gray-300 mb-0.5">
// // //                 {tc("pickupDate", "Pickup Date")}
// // //               </div>
// // //               <input
// // //                 type="date"
// // //                 value={pickupDate}
// // //                 onChange={(e) => setPickupDate(e.target.value)}
// // //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// // //               />
// // //             </div>

// // //             {/* Time */}
// // //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// // //               <div className="text-[10px] text-gray-300 mb-0.5">
// // //                 {tc("pickupTime", "Pickup Time")}
// // //               </div>
// // //               <input
// // //                 type="time"
// // //                 value={pickupTime}
// // //                 onChange={(e) => setPickupTime(e.target.value)}
// // //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// // //               />
// // //             </div>

// // //             {/* Passengers */}
// // //             <div className="col-span-2 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// // //               <FaUsers className="shrink-0 text-[12px]" />
// // //               <select
// // //                 value={passengerCount}
// // //                 onChange={(e) => setPassengerCount(e.target.value)}
// // //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// // //               >
// // //                 {[...Array(14)].map((_, i) => (
// // //                   <option key={i + 1} value={i + 1} className="text-black text-[11px]">
// // //                     {tc("passengers", "Passengers")}: {i + 1}
// // //                   </option>
// // //                 ))}
// // //               </select>
// // //             </div>
// // //           </div>

// // //           {/* WhatsApp */}
// // //           <div className="mt-2 flex justify-center">
// // //             <button
// // //               type="button"
// // //               onClick={handleWhatsApp}
// // //               className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
// // //             >
// // //               <FaWhatsapp /> {tc("whatsappCta", "Get a Price on WhatsApp")}
// // //             </button>
// // //           </div>
// // //         </form>
// // //       </div>

// // //       <style>{`
// // //         .no-scrollbar::-webkit-scrollbar { display: none; }
// // //         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
// // //       `}</style>
// // //     </div>
// // //   );
// // // }
// // import React, { useMemo, useState, useEffect } from "react";
// // import { useNavigate } from "react-router-dom";
// // import { useTranslation } from "react-i18next";
// // import { usePriceData } from "../context/PriceContext";
// // import { convertPrice } from "../utils/currencyRates";
// // import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
// // import i18n from "i18next";

// // const IMG = {
// //   MERCEDES8: "/images/vehicles/mercedes8.png",
// //   TRANSPORTER: "/images/vehicles/transporter.jpg",
// //   SPRINTER: "/images/vehicles/sprinter.png",
// // };

// // const VEHICLES_ALL = [
// //   { key: "MERCEDES8", name: "Mercedes Vito", capacity: 6, img: IMG.MERCEDES8, match: ["VITO", "MERCEDES8", "MERCEDES"] },
// //   { key: "TRANSPORTER", name: "Transporter", capacity: 6, img: IMG.TRANSPORTER, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
// //   { key: "SPRINTER", name: "Sprinter (Minibus)", capacity: 13, img: IMG.SPRINTER, match: ["SPRINTER", "MINIBUS", "BUS"] },
// // ];

// // function findPriceKey(regionPrices, matchKeywords) {
// //   if (!regionPrices) return null;
// //   const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
// //   for (const kw of matchKeywords) {
// //     const hit = upper.find(([, U]) => U.includes(kw));
// //     if (hit) return hit[0];
// //   }
// //   return null;
// // }

// // // === i18n Title-Case helper ===
// // function toTitleCase(s) {
// //   return s
// //     .replace(/[_-]/g, " ")
// //     .replace(/([a-z])([A-Z])/g, "$1 $2")
// //     .replace(/\s+/g, " ")
// //     .trim()
// //     .replace(/(^|\s)\S/g, (c) => c.toUpperCase());
// // }
// // function useTc(ns) {
// //   const { t } = useTranslation(ns);
// //   return (key, fallback) => {
// //     const raw = t(key, { defaultValue: fallback });
// //     if (!raw || raw === key) return fallback;
// //     return toTitleCase(raw);
// //   };
// // }

// // export default function MobileTransferSearch() {
// //   const navigate = useNavigate();
// //   const tc = useTc("searchbox");
// //   const pricesByRegionAndVehicle = usePriceData();

// //   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
// //   const [selectedTo, setSelectedTo] = useState("");
// //   const [passengerCount, setPassengerCount] = useState("1");

// //   const todayISO = new Date().toISOString().split("T")[0];
// //   const nextHour = (() => {
// //     const d = new Date();
// //     d.setMinutes(0, 0, 0);
// //     d.setHours(d.getHours() + 1);
// //     return d.toTimeString().slice(0, 5);
// //   })();
// //   const [pickupDate, setPickupDate] = useState(todayISO);
// //   const [pickupTime, setPickupTime] = useState(nextHour);

// //   const regionOptions = useMemo(
// //     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
// //     [pricesByRegionAndVehicle]
// //   );

// //   let regionKey = null;
// //   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
// //   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
// //   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

// //   const pax = Number(passengerCount || 1);
// //   const allowedVehicles = pax <= 6 ? [VEHICLES_ALL[0], VEHICLES_ALL[1]] : [VEHICLES_ALL[2]];

// //   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
// //   useEffect(() => { setSelectedVehicleKey(allowedVehicles[0].key); }, [pax]); // pax değişince defaultu ayarla

// //   const priceForVehicle = (v) => {
// //     if (!regionPrices) return null;
// //     const k = findPriceKey(regionPrices, v.match) || v.key;
// //     const raw = regionPrices[k];
// //     return raw ? convertPrice(raw, i18n.language) : null;
// //   };

// //   const selectedVehicleDef =
// //     allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

// //   const handleSearch = (e) => {
// //     e.preventDefault();
// //     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
// //     navigate(
// //       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
// //         selectedTo
// //       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
// //         selectedVehicleKey
// //       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
// //     );
// //   };

// //   const handleWhatsApp = () => {
// //     if (!selectedFrom || !selectedTo) return;
// //     const msg =
// //       `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
// //       `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
// //       `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
// //       `ANTALYA VIP TRANSFER`;
// //     const phone = "905466830127";
// //     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
// //   };

// //   // ---- VEHICLE DROPDOWN (resimli) ----
// //   function VehicleDropdown() {
// //     const [open, setOpen] = useState(false);
// //     const btnRef = React.useRef(null);
// //     const listRef = React.useRef(null);

// //     // dışarı tıklayınca kapat
// //     useEffect(() => {
// //       function onClick(e) {
// //         if (
// //           btnRef.current &&
// //           !btnRef.current.contains(e.target) &&
// //           listRef.current &&
// //           !listRef.current.contains(e.target)
// //         ) setOpen(false);
// //       }
// //       document.addEventListener("mousedown", onClick);
// //       return () => document.removeEventListener("mousedown", onClick);
// //     }, []);

// //     const selected = allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

// //     return (
// //       <div className="relative">
// //         <button
// //           ref={btnRef}
// //           type="button"
// //           aria-haspopup="listbox"
// //           aria-expanded={open}
// //           onClick={() => setOpen(o => !o)}
// //           className="w-full rounded-md bg-gray-900 border border-white/20 px-2 py-2 text-left"
// //         >
// //           <div className="flex items-center gap-2">
// //             <img src={selected.img} alt="" className="h-8 w-12 rounded object-cover" />
// //             <div className="min-w-0">
// //               <div className="text-white text-[12px] font-semibold truncate">{selected.name}</div>
// //               <div className="text-[11px] text-gray-400">
// //                 {tc("passengers", "Passengers")}: {selected.capacity}
// //                 {priceForVehicle(selected) && (
// //                   <span className="ml-2 text-yellow-400 font-bold">{priceForVehicle(selected)}</span>
// //                 )}
// //               </div>
// //             </div>
// //             <svg className="ml-auto opacity-70" width="18" height="18" viewBox="0 0 20 20">
// //               <path d="M5.5 7.5L10 12l4.5-4.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
// //             </svg>
// //           </div>
// //         </button>

// //         {open && (
// //           <ul
// //             ref={listRef}
// //             role="listbox"
// //             className="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-md bg-[#0b1220] border border-white/10 shadow-xl"
// //           >
// //             {allowedVehicles.map(v => (
// //               <li
// //                 key={v.key}
// //                 role="option"
// //                 aria-selected={v.key === selectedVehicleKey}
// //                 onClick={() => { setSelectedVehicleKey(v.key); setOpen(false); }}
// //                 className="px-2 py-2 cursor-pointer hover:bg-white/10 flex items-center gap-2"
// //               >
// //                 <img src={v.img} alt="" className="h-8 w-12 rounded object-cover" />
// //                 <div className="flex-1 min-w-0">
// //                   <div className="text-white text-[12px] font-semibold truncate">{v.name}</div>
// //                   <div className="text-[11px] text-gray-400">
// //                     {tc("passengers", "Passengers")}: {v.capacity}
// //                   </div>
// //                 </div>
// //                 {priceForVehicle(v) && (
// //                   <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
// //                     {priceForVehicle(v)}
// //                   </div>
// //                 )}
// //               </li>
// //             ))}
// //           </ul>
// //         )}
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="md:hidden text-white">
// //       {/* Kart */}
// //       <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
// //         <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
// //           {tc("quickReservation", "Quick Reservation")}
// //         </h4>

// //         <form onSubmit={handleSearch} className="relative">
// //           <div className="grid grid-cols-2 gap-x-2 gap-y-2">
// //             {/* From */}
// //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// //               <select
// //                 value={selectedFrom}
// //                 onChange={(e) => setSelectedFrom(e.target.value)}
// //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// //               >
// //                 {regionOptions.map((r, i) => (
// //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// //                 ))}
// //               </select>
// //             </div>

// //             {/* To */}
// //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// //               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
// //               <select
// //                 value={selectedTo}
// //                 onChange={(e) => setSelectedTo(e.target.value)}
// //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// //               >
// //                 <option value="">{tc("toPlaceholder", "Select Drop-off Location")}</option>
// //                 {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
// //                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
// //                 ))}
// //               </select>
// //             </div>

// //             {/* === VEHICLE (Resimli Dropdown) === */}
// //             <div className="col-span-2 bg-gray-800 rounded-md p-1.5 relative">
// //               <div className="text-[11px] text-gray-300 mb-1">
// //                 {tc("vehicleSelection", "Vehicle Selection")}
// //               </div>
// //               <VehicleDropdown />
// //             </div>

// //             {/* Date */}
// //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// //               <div className="text-[10px] text-gray-300 mb-0.5">
// //                 {tc("pickupDate", "Pickup Date")}
// //               </div>
// //               <input
// //                 type="date"
// //                 value={pickupDate}
// //                 onChange={(e) => setPickupDate(e.target.value)}
// //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// //               />
// //             </div>

// //             {/* Time */}
// //             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
// //               <div className="text-[10px] text-gray-300 mb-0.5">
// //                 {tc("pickupTime", "Pickup Time")}
// //               </div>
// //               <input
// //                 type="time"
// //                 value={pickupTime}
// //                 onChange={(e) => setPickupTime(e.target.value)}
// //                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[26px]"
// //               />
// //             </div>

// //             {/* Passengers */}
// //             <div className="col-span-2 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
// //               <FaUsers className="shrink-0 text-[12px]" />
// //               <select
// //                 value={passengerCount}
// //                 onChange={(e) => setPassengerCount(e.target.value)}
// //                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
// //               >
// //                 {[...Array(14)].map((_, i) => (
// //                   <option key={i + 1} value={i + 1} className="text-black text-[11px]">
// //                     {tc("passengers", "Passengers")}: {i + 1}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>
// //           </div>

// //           {/* WhatsApp */}
// //           <div className="mt-2 flex justify-center">
// //             <button
// //               type="button"
// //               onClick={handleWhatsApp}
// //               className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
// //             >
// //               <FaWhatsapp /> {tc("whatsappCta", "Get a Price on WhatsApp")}
// //             </button>
// //           </div>
// //         </form>
// //       </div>

// //       <style>{`
// //         .no-scrollbar::-webkit-scrollbar { display: none; }
// //         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
// //       `}</style>
// //     </div>
// //   );
// // }
// import React, { useMemo, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { usePriceData } from "../context/PriceContext";
// import { convertPrice } from "../utils/currencyRates";
// import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
// import i18n from "i18next";

// const IMG = {
//   MERCEDES8: "/images/vehicles/mercedes8.png",
//   TRANSPORTER: "/images/vehicles/transporter.jpg",
//   SPRINTER: "/images/vehicles/sprinter.png",
// };

// const VEHICLES_ALL = [
//   { key: "MERCEDES8", name: "Mercedes Vito",        img: IMG.MERCEDES8,  capacity: 6,  match: ["VITO", "MERCEDES8", "MERCEDES"] },
//   { key: "TRANSPORTER", name: "Transporter",        img: IMG.TRANSPORTER, capacity: 6,  match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
//   { key: "SPRINTER",    name: "Sprinter (Minibus)", img: IMG.SPRINTER,    capacity: 15, match: ["SPRINTER", "MINIBUS", "BUS"] },
// ];

// function findPriceKey(regionPrices, matchKeywords) {
//   if (!regionPrices) return null;
//   const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
//   for (const kw of matchKeywords) {
//     const hit = upper.find(([, U]) => U.includes(kw));
//     if (hit) return hit[0];
//   }
//   return null;
// }

// // i18n Title-Case helper
// function toTitleCase(s) {
//   return s
//     .replace(/[_-]/g, " ")
//     .replace(/([a-z])([A-Z])/g, "$1 $2")
//     .replace(/\s+/g, " ")
//     .trim()
//     .replace(/(^|\s)\S/g, (c) => c.toUpperCase());
// }
// function useTc(ns) {
//   const { t } = useTranslation(ns);
//   return (key, fallback) => {
//     const raw = t(key, { defaultValue: fallback });
//     if (!raw || raw === key) return fallback;
//     return toTitleCase(raw);
//   };
// }

// export default function MobileTransferSearch() {
//   const navigate = useNavigate();
//   const tc = useTc("searchbox");
//   const pricesByRegionAndVehicle = usePriceData();

//   const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
//   const [selectedTo, setSelectedTo] = useState("");
//   const [passengerCount, setPassengerCount] = useState("1");

//   const todayISO = new Date().toISOString().split("T")[0];
//   const nextHour = (() => {
//     const d = new Date();
//     d.setMinutes(0, 0, 0);
//     d.setHours(d.getHours() + 1);
//     return d.toTimeString().slice(0, 5);
//   })();
//   const [pickupDate, setPickupDate] = useState(todayISO);
//   const [pickupTime, setPickupTime] = useState(nextHour);

//   const regionOptions = useMemo(
//     () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
//     [pricesByRegionAndVehicle]
//   );

//   let regionKey = null;
//   if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
//   else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
//   const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

//   const pax = Number(passengerCount || 1);

//   // 1–6: Vito + Transporter + Sprinter, 7–15: sadece Sprinter
//   const allowedVehicles = useMemo(() => {
//     if (pax >= 7) return [VEHICLES_ALL[2]];
//     return [VEHICLES_ALL[0], VEHICLES_ALL[1], VEHICLES_ALL[2]];
//   }, [pax]);

//   const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
//   useEffect(() => { setSelectedVehicleKey(allowedVehicles[0].key); }, [allowedVehicles]);

//   const priceForVehicle = (v) => {
//     if (!regionPrices) return null;
//     const k = findPriceKey(regionPrices, v.match) || v.key;
//     const raw = regionPrices[k];
//     return raw ? convertPrice(raw, i18n.language) : null;
//   };

//   const selectedVehicleDef =
//     allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
//     navigate(
//       `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
//         selectedTo
//       )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
//         selectedVehicleKey
//       )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
//     );
//   };

//   const handleWhatsApp = () => {
//     if (!selectedFrom || !selectedTo) return;
//     const msg =
//       `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
//       `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
//       `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
//       `ANTALYA VIP TRANSFER`;
//     const phone = "905466830127";
//     window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
//   };

//   // ---- VEHICLE DROPDOWN (resimli, "Passengers:" yazısı YOK) ----
//   function VehicleDropdown() {
//     const [open, setOpen] = useState(false);
//     const btnRef = React.useRef(null);
//     const listRef = React.useRef(null);

//     useEffect(() => {
//       function onClick(e) {
//         if (
//           btnRef.current &&
//           !btnRef.current.contains(e.target) &&
//           listRef.current &&
//           !listRef.current.contains(e.target)
//         ) setOpen(false);
//       }
//       document.addEventListener("mousedown", onClick);
//       return () => document.removeEventListener("mousedown", onClick);
//     }, []);

//     const selected = allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

//     return (
//       <div className="relative">
//         <button
//           ref={btnRef}
//           type="button"
//           aria-haspopup="listbox"
//           aria-expanded={open}
//           onClick={() => setOpen(o => !o)}
//           className="w-full rounded-md bg-gray-900 border border-white/20 px-2 py-2 text-left"
//         >
//           <div className="flex items-center gap-2">
//             <img src={selected.img} alt="" className="h-8 w-12 rounded object-cover" />
//             <div className="min-w-0">
//               <div className="text-white text-[12px] font-semibold truncate">{selected.name}</div>
//               {priceForVehicle(selected) && (
//                 <div className="text-[12px] text-yellow-400 font-bold">
//                   {priceForVehicle(selected)}
//                 </div>
//               )}
//             </div>
//             <svg className="ml-auto opacity-70" width="18" height="18" viewBox="0 0 20 20">
//               <path d="M5.5 7.5L10 12l4.5-4.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//             </svg>
//           </div>
//         </button>

//         {open && (
//           <ul
//             ref={listRef}
//             role="listbox"
//             className="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-md bg-[#0b1220] border border-white/10 shadow-xl"
//           >
//             {allowedVehicles.map(v => (
//               <li
//                 key={v.key}
//                 role="option"
//                 aria-selected={v.key === selectedVehicleKey}
//                 onClick={() => { setSelectedVehicleKey(v.key); setOpen(false); }}
//                 className="px-2 py-2 cursor-pointer hover:bg-white/10 flex items-center gap-2"
//               >
//                 <img src={v.img} alt="" className="h-8 w-12 rounded object-cover" />
//                 <div className="flex-1 min-w-0">
//                   <div className="text-white text-[12px] font-semibold truncate">{v.name}</div>
//                 </div>
//                 {priceForVehicle(v) && (
//                   <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
//                     {priceForVehicle(v)}
//                   </div>
//                 )}
//               </li>
//             ))}
//           </ul>
//         )}
//       </div>
//     );
//   }

//   return (
//     <div className="md:hidden text-white">
//       <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
//         <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
//           {tc("quickReservation", "Quick Reservation")}
//         </h4>

//         <form onSubmit={handleSearch} className="relative">
//           <div className="grid grid-cols-2 gap-x-2 gap-y-2">
//             {/* From */}
//             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
//               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
//               <select
//                 value={selectedFrom}
//                 onChange={(e) => setSelectedFrom(e.target.value)}
//                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
//               >
//                 {regionOptions.map((r, i) => (
//                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
//                 ))}
//               </select>
//             </div>

//             {/* To */}
//             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
//               <FaMapMarkerAlt className="shrink-0 text-[12px]" />
//               <select
//                 value={selectedTo}
//                 onChange={(e) => setSelectedTo(e.target.value)}
//                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
//               >
//                 <option value="">{tc("toPlaceholder", "Select Drop-off Location")}</option>
//                 {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
//                   <option key={i} value={r} className="text-black text-[11px]">{r}</option>
//                 ))}
//               </select>
//             </div>

//             {/* Vehicle (Dropdown) */}
//             <div className="col-span-2 bg-gray-800 rounded-md p-1.5 relative">
//               <div className="text-[11px] text-gray-300 mb-1">
//                 {tc("vehicleSelection", "Vehicle Selection")}
//               </div>
//               <VehicleDropdown />
//             </div>

//             {/* Date */}
//             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
//               <div className="text-[10px] text-gray-300 mb-0.5">
//                 {tc("pickupDate", "Pickup Date")}
//               </div>
//               <input
//                 type="date"
//                 value={pickupDate}
//                 onChange={(e) => setPickupDate(e.target.value)}
//                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[18px]"
//               />
//             </div>

//             {/* Time */}
//             <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
//               <div className="text-[10px] text-gray-300 mb-0.5">
//                 {tc("pickupTime", "Pickup Time")}
//               </div>
//               <input
//                 type="time"
//                 value={pickupTime}
//                 onChange={(e) => setPickupTime(e.target.value)}
//                 className="w-full bg-transparent text-white focus:outline-none text-[11px] h-[18px]"
//               />
//             </div>

//             {/* Passengers (1–15) */}
//             <div className="col-span-2 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
//               <FaUsers className="shrink-0 text-[12px]" />
//               <select
//                 value={passengerCount}
//                 onChange={(e) => setPassengerCount(e.target.value)}
//                 className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
//               >
//                 {[...Array(15)].map((_, i) => (
//                   <option key={i + 1} value={i + 1} className="text-black text-[11px]">
//                     {tc("passengers", "Passengers")}: {i + 1}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* WhatsApp */}
//           <div className="mt-2 flex justify-center">
//             <button
//               type="button"
//               onClick={handleWhatsApp}
//               className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
//             >
//               <FaWhatsapp /> {tc("whatsappCta", "Get a Price on WhatsApp")}
//             </button>
//           </div>
//         </form>
//       </div>

//       <style>{`
//         .no-scrollbar::-webkit-scrollbar { display: none; }
//         .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
//       `}</style>
//     </div>
//   );
// }
import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePriceData } from "../context/PriceContext";
import { convertPrice } from "../utils/currencyRates";
import { FaMapMarkerAlt, FaUsers, FaWhatsapp } from "react-icons/fa";
import i18n from "i18next";

const IMG = {
  MERCEDES8: "/images/vehicles/mercedes8.png",
  TRANSPORTER: "/images/vehicles/transporter.jpg",
  SPRINTER: "/images/vehicles/sprinter.png",
};

const VEHICLES_ALL = [
  { key: "MERCEDES8", name: "Mercedes Vito", img: IMG.MERCEDES8, capacity: 6, match: ["VITO", "MERCEDES8", "MERCEDES"] },
  { key: "TRANSPORTER", name: "Transporter", img: IMG.TRANSPORTER, capacity: 6, match: ["TRANSPORTER", "TRANS", "CARAVELLE"] },
  { key: "SPRINTER", name: "Sprinter (Minibus)", img: IMG.SPRINTER, capacity: 15, match: ["SPRINTER", "MINIBUS", "BUS"] },
];

function findPriceKey(regionPrices, matchKeywords) {
  if (!regionPrices) return null;
  const upper = Object.keys(regionPrices).map(k => [k, k.toUpperCase()]);
  for (const kw of matchKeywords) {
    const hit = upper.find(([, U]) => U.includes(kw));
    if (hit) return hit[0];
  }
  return null;
}

// i18n Title-Case helper
function toTitleCase(s) {
  return s
    .replace(/[_-]/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/(^|\s)\S/g, (c) => c.toUpperCase());
}
function useTc(ns) {
  const { t } = useTranslation(ns);
  return (key, fallback) => {
    const raw = t(key, { defaultValue: fallback });
    if (!raw || raw === key) return fallback;
    return toTitleCase(raw);
  };
}

export default function MobileTransferSearch() {
  const navigate = useNavigate();
  const tc = useTc("searchbox");
  const pricesByRegionAndVehicle = usePriceData();

  const [selectedFrom, setSelectedFrom] = useState("Antalya Havalimanı");
  const [selectedTo, setSelectedTo] = useState("");
  const [passengerCount, setPassengerCount] = useState("1");

  const todayISO = new Date().toISOString().split("T")[0];
  const nextHour = (() => {
    const d = new Date();
    d.setMinutes(0, 0, 0);
    d.setHours(d.getHours() + 1);
    return d.toTimeString().slice(0, 5);
  })();
  const [pickupDate, setPickupDate] = useState(todayISO);
  const [pickupTime, setPickupTime] = useState(nextHour);

  const regionOptions = useMemo(
    () => ["Antalya Havalimanı", ...Object.keys(pricesByRegionAndVehicle || {})],
    [pricesByRegionAndVehicle]
  );

  let regionKey = null;
  if (selectedFrom === "Antalya Havalimanı" && selectedTo) regionKey = selectedTo.toUpperCase();
  else if (selectedTo === "Antalya Havalimanı" && selectedFrom) regionKey = selectedFrom.toUpperCase();
  const regionPrices = regionKey ? pricesByRegionAndVehicle?.[regionKey] : null;

  const pax = Number(passengerCount || 1);

  // 1–6: Vito + Transporter + Sprinter, 7–15: sadece Sprinter
  const allowedVehicles = useMemo(() => {
    if (pax >= 7) return [VEHICLES_ALL[2]];
    return [VEHICLES_ALL[0], VEHICLES_ALL[1], VEHICLES_ALL[2]];
  }, [pax]);

  const [selectedVehicleKey, setSelectedVehicleKey] = useState(allowedVehicles[0].key);
  useEffect(() => {
    setSelectedVehicleKey(allowedVehicles[0].key);
  }, [allowedVehicles]);

  const priceForVehicle = (v) => {
    if (!regionPrices) return null;
    const k = findPriceKey(regionPrices, v.match) || v.key;
    const raw = regionPrices[k];
    return raw ? convertPrice(raw, i18n.language) : null;
  };

  const selectedVehicleDef =
    allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

  const handleSearch = (e) => {
    e.preventDefault();
    if (!selectedFrom || !selectedTo || !pickupDate || !pickupTime || !selectedVehicleKey) return;
    navigate(
      `/arac-secimi?from=${encodeURIComponent(selectedFrom)}&to=${encodeURIComponent(
        selectedTo
      )}&passengers=${passengerCount}&vehicle=${encodeURIComponent(
        selectedVehicleKey
      )}&pickupDate=${encodeURIComponent(pickupDate)}&pickupTime=${encodeURIComponent(pickupTime)}`
    );
  };

  const handleWhatsApp = () => {
    if (!selectedFrom || !selectedTo) return;
    const msg =
      `Date: ${pickupDate}\nTime: ${pickupTime}\n` +
      `From: ${selectedFrom}\nTo: ${selectedTo}\n` +
      `Persons: ${passengerCount}\nCar: ${selectedVehicleDef.name}\n\n` +
      `ANTALYA VIP TRANSFER`;
    const phone = "905466830127";
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
  };

  // ---- VEHICLE DROPDOWN ----
  function VehicleDropdown() {
    const [open, setOpen] = useState(false);
    const btnRef = React.useRef(null);
    const listRef = React.useRef(null);

    useEffect(() => {
      function onClick(e) {
        if (
          btnRef.current &&
          !btnRef.current.contains(e.target) &&
          listRef.current &&
          !listRef.current.contains(e.target)
        )
          setOpen(false);
      }
      document.addEventListener("mousedown", onClick);
      return () => document.removeEventListener("mousedown", onClick);
    }, []);

    const selected =
      allowedVehicles.find(v => v.key === selectedVehicleKey) || allowedVehicles[0];

    return (
      <div className="relative">
        <button
          ref={btnRef}
          type="button"
          aria-haspopup="listbox"
          aria-expanded={open}
          onClick={() => setOpen(o => !o)}
          className="w-full rounded-md bg-gray-900 border border-white/20 px-2 py-2 text-left"
        >
          <div className="flex items-center gap-2">
            <img src={selected.img} alt="" className="h-8 w-12 rounded object-cover" />
            <div className="min-w-0">
              <div className="text-white text-[12px] font-semibold truncate">{selected.name}</div>
              {priceForVehicle(selected) && (
                <div className="text-[12px] text-yellow-400 font-bold">
                  {priceForVehicle(selected)}
                </div>
              )}
            </div>
            <svg className="ml-auto opacity-70" width="18" height="18" viewBox="0 0 20 20">
              <path
                d="M5.5 7.5L10 12l4.5-4.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </button>

        {open && (
          <ul
            ref={listRef}
            role="listbox"
            className="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-md bg-[#0b1220] border border-white/10 shadow-xl"
          >
            {allowedVehicles.map(v => (
              <li
                key={v.key}
                role="option"
                aria-selected={v.key === selectedVehicleKey}
                onClick={() => {
                  setSelectedVehicleKey(v.key);
                  setOpen(false);
                }}
                className="px-2 py-2 cursor-pointer hover:bg-white/10 flex items-center gap-2"
              >
                <img src={v.img} alt="" className="h-8 w-12 rounded object-cover" />
                <div className="flex-1 min-w-0">
                  <div className="text-white text-[12px] font-semibold truncate">{v.name}</div>
                </div>
                {priceForVehicle(v) && (
                  <div className="text-[12px] font-bold text-yellow-400 whitespace-nowrap">
                    {priceForVehicle(v)}
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  return (
    <div className="md:hidden text-white">
      <div className="w-[95vw] mx-auto bg-[#0f172a] rounded-2xl shadow-inner px-2.5 pt-2 pb-3">
        <h4 className="text-center text-[14px] font-semibold text-yellow-500 mb-1">
          {tc("quickReservation", "Quick Reservation")}
        </h4>

        <form onSubmit={handleSearch} className="relative">
          <div className="grid grid-cols-2 gap-x-2 gap-y-2">
            {/* From */}
            <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
              <FaMapMarkerAlt className="shrink-0 text-[12px]" />
              <select
                value={selectedFrom}
                onChange={(e) => setSelectedFrom(e.target.value)}
                className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
              >
                {regionOptions.map((r, i) => (
                  <option key={i} value={r} className="text-black text-[11px]">
                    {r}
                  </option>
                ))}
              </select>
            </div>

            {/* To */}
            <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
              <FaMapMarkerAlt className="shrink-0 text-[12px]" />
              <select
                value={selectedTo}
                onChange={(e) => setSelectedTo(e.target.value)}
                className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
              >
                <option value="">
                  {tc("toPlaceholder", "Select Drop-off Location")}
                </option>
                {regionOptions.filter(r => r !== selectedFrom).map((r, i) => (
                  <option key={i} value={r} className="text-black text-[11px]">
                    {r}
                  </option>
                ))}
              </select>
            </div>

            {/* Vehicle (Dropdown) */}
            <div className="col-span-2 bg-gray-800 rounded-md p-1.5 relative">
              <div className="text-[11px] text-gray-300 mb-1">
                {tc("vehicleSelection", "Vehicle Selection")}
              </div>
              <VehicleDropdown />
            </div>

            {/* Date */}
            <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
              <div className="text-[10px] text-gray-300 mb-0.5">
                {tc("pickupDate", "Pickup Date")}
              </div>
              <input
                type="date"
                value={pickupDate}
                onChange={(e) => setPickupDate(e.target.value)}
                className="w-full bg-transparent text-white focus:outline-none text-[10px] h-[22px] appearance-none leading-tight"
              />
            </div>

            {/* Time */}
            <div className="col-span-1 bg-gray-800 px-2 py-1 rounded-md">
              <div className="text-[10px] text-gray-300 mb-0.5">
                {tc("pickupTime", "Pickup Time")}
              </div>
              <input
                type="time"
                value={pickupTime}
                onChange={(e) => setPickupTime(e.target.value)}
                className="w-full bg-transparent text-white focus:outline-none text-[10px] h-[22px] appearance-none leading-tight"
              />
            </div>

            {/* Passengers */}
            <div className="col-span-2 bg-gray-800 px-2 py-1 rounded-md flex items-center gap-1">
              <FaUsers className="shrink-0 text-[12px]" />
              <select
                value={passengerCount}
                onChange={(e) => setPassengerCount(e.target.value)}
                className="bg-transparent text-white w-full focus:outline-none text-[11px] h-[26px]"
              >
                {[...Array(15)].map((_, i) => (
                  <option key={i + 1} value={i + 1} className="text-black text-[11px]">
                    {tc("passengers", "Passengers")}: {i + 1}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="mt-2 flex justify-center">
            <button
              type="button"
              onClick={handleWhatsApp}
              className="w-[90%] h-[40px] rounded-lg bg-green-500 hover:bg-green-600 text-white font-semibold flex items-center justify-center gap-2"
            >
              <FaWhatsapp /> {tc("whatsappCta", "Get a Price on WhatsApp")}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}
